import React, { Component } from "react";
import IPSDataService from "../services/ips.service";
import countryList from 'react-select-country-list';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import Tooltip from '@mui/material/Tooltip';
import ReactTooltip from 'react-tooltip';
import Chart from 'react-google-charts';
import { Modal, } from "react-bootstrap";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import {Table, Thead, Tbody, Tr, Th, Td} from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
export default class Home extends Component {

   
   
    constructor(props) {
      super(props);
      this.onChangeSelectedLifeCycleState = this.onChangeSelectedLifeCycleState.bind(this);
      this.onChangeSelectedCapitalSafety = this.onChangeSelectedCapitalSafety.bind(this);
      this.onChangeSelectedRiskPreference = this.onChangeSelectedRiskPreference.bind(this);
      this.onChangeSelectedProductPreference = this.onChangeSelectedProductPreference.bind(this);
      this.onChangeEmail = this.onChangeEmail.bind(this);
      this.onChangeFirstName = this.onChangeFirstName.bind(this);
      this.onChangeContact = this.onChangeContact.bind(this);
      this.onChangeLastName = this.onChangeLastName.bind(this);
      this.onChangePassword = this.onChangePassword.bind(this);
      this.onChangeRePassword = this.onChangeRePassword.bind(this);
      this.onChangePolicyCheck = this.onChangePolicyCheck.bind(this);
      this.options = countryList().getData();

      //  var date= moment().format("YYYY-MM-DD");
      this.state = {
         _100DollarChart : [],
        id: null,
        email:"",
        contact:"",
        fname:"",
        lname:"",
        password:"",
        repassword: "",
        submitted: false,
        pdfGenerationButtonText: "Generate PDF",
        captchacheck:false,
        operator:'',
        reloadbtn:true,
        needreloadbtnclick:false,
        sumOfWeights:'',
        showModal: false,
        showModalTandC: false,
        showModalSkipSteps: false,
        showModalLifeCycleState: false,  
        showModalHighestPotential: false,
        showProgressBar:false,
        policycheck: true,
        screenWidth:window.innerWidth,
        message:'',
        emailMessage:'',
        Primaryoption1:0,
        Primaryoption4:0,
        sectionHeading1:'Understanding your investment objectives, preferences, as well as your border circumstances',
        sectionHeading2:'Understanding your risk tolerance',
        dataFillingMessageError:'Error: Please Select portfolio size in section 5',
        portfolioSizeCheck: 0,
        dataFillingMessageSuccess:'',
        TypesOfQuestionaresList:'Loading options',
        sectionQuestions1_0:[],
        sectionQuestions1_1:[],
        sectionQuestions1_2:[],
        sectionQuestions1_3:[],
        sectionQuestions1_4:[],
        sectionQuestions1_5:[],
        sectionQuestions1_6:[],
        sectionQuestions1_7:[],
        sectionQuestions1_8:[],
        sectionQuestions1_9:[],
        sectionQuestions2_1:[],
        sectionQuestions2_1_Answered:false,
        sectionQuestions1_4_Answered:false,
        sectionQuestions1_5_Answered:false,
        LifeCycleState : [ ],
        sectionQuestions2_1_Sliders:[[{ value: 5, label: 'The safety of investment capital is the only concern'},{ value: 10, label: 'The safety of the investment principal is of primary concern while capital appreciation is secondary'},{ value: 15, label: 'Potentially increase the portfolio\'s value at a moderate pace while accepting moderate to high levels of risk'},{ value: 20, label: 'Potentially increase the portfolio\'s value as quickly as possible while accepting higher levels of risk'}],
                                     [{ value: 5, label: 'Having a relative level of stability in the Principal’s overall investment portfolio' },{ value: 10, label: 'Slightly increasing the investment value while minimizing the potential for loss of principal' },{ value: 15, label: 'Pursue moderate investment growth, accepting moderate levels of risk, and principal fluctuation' },{ value: 20, label: 'Pursue investment growth, accepting moderate to high levels of risk, and principal fluctuation' },{ value: 25, label: 'Seek maximum long-term returns, accepting maximum risk with high principal fluctuation' }],
                                     [{ value: 5, label: 'A highly liquid money-market instrument that provides a return at the rate of inflation' },{ value: 10, label: 'A yielding real estate investment with regular dividend payments and a defined exit date' },{ value: 15, label: 'An established, well-known company that has the potential for continued growth and pays dividends occasionally' },{ value: 20, label: 'A recently established company that may make significant technological advances but whose future is still uncertain hence pays no dividends currently' }]
                                    ],
         PreliminaryRiskAssessmentChart: [],
         SelectedLifeCycleState:0,
         SelectedCapitalSafety:0,
         SelectedRiskPreference:0,
         SelectedProductPreference:0,
         SelectedQuestionareType:0,
         CalculatedModelType:'',
         CalculatedModelTypeValues:[],
         Custom_Model:'',
         Custom_ModelArray:[],
         CustomModelChart: [],
         _ALL_Models:[],
         ALL_MODEL_DETAILS_Array:[]
      };
    }

     componentDidMount() 
    {  
        this.retrieveTypesOfQuestionares();
    }
    
      closeModal()
      {
         this.setState({
         showModal: false,
         message:""
         });
         
      }

      closeModalTandC()
      {
         this.setState({
         showModalTandC: false,
         
         });
         
      }

      closeModalSkipSteps()
      {
         this.setState({
         showModalSkipSteps: false,
         
         });
         
      }

      closeModalSkipStepsAndOpenOther()
      {
         this.setState({
         showModalSkipSteps: false,
         
         });
         document.getElementById('firstStep').style.display= 'none';
         document.getElementById('1523').click();
         setTimeout(

      
            function() {
               document.getElementById('buttonForm').click();
            }
            .bind(this),
            1000
          );
        
         
        
         
      }

      closeModalLifeCycleState()
      {
         this.setState({
         showModalLifeCycleState: false,
         
         });
         
      }   

      closeModalHighestPotential()
      {
         this.setState({
         showModalHighestPotential: false,
         
         });
         
      }

      onChangePolicyCheck(e) {

         this.setState({policycheck: !this.state.policycheck})
       }

   closeModalAndGoBack()
   {
      this.setState({
      showModal: false,
      message:""
      });
      document.getElementById('go-back-slider').click();
      
   }
  
   openModal()
   {    
        if(this.state.submitted==false)
        {
         this.setState({
         showModal: true,
         message:""
         });
      }
   }

   openModalTandC()
   {    
       
         this.setState({
         showModalTandC: true
         });
      
   }

   openModalSkipSteps()
   {    
       
         this.setState({
         showModalSkipSteps: true
         });
      
   }

   openModalLifeCycleState()
   {    
       
         this.setState({
         showModalLifeCycleState: true
         });
      
   }

   openModalHighestPotential()
   {
      this.setState({
      showModalHighestPotential: true,
      
      });
      
   }
  
   actionModal()
   {
   }

   actionModalSubmit()
   {
      this.saveAccount();
   }

   onChangeEmail(e) 
   {
     this.setState({
       email: e.target.value
     });
   }

   onChangeFirstName(e)
    {
     this.setState({
       fname: e.target.value
     });
   }

   onChangeContact(e) 
   {
      this.setState({
         contact: e.target.value
      });
    }

   onChangeLastName(e) 
   {
     this.setState({
       lname: e.target.value
     });
   }
 
   onChangePassword(e)
    {
     this.setState({
       password: e.target.value
     });
   }
 
   onChangeRePassword(e) 
   {
     this.setState({
       repassword: e.target.value
     });
   }



   emailCustomUser(suggested, model, r, y , sd, sr, assets) {
     
      if(!this.state.submitted)
      {
         this.openModal();
      }
      
      else
      {
         
         
         let emailTable=  '<label htmlFor="suggested">Suggested Model:</label><input type="text" style="border-style : hidden;" name="suggested" value="' +suggested +'"readonly><br><br></br>';
         emailTable=  emailTable+ '<label htmlFor="customModel">Custom Model:</label><input type="text" style="border-style : hidden;" name="customModel" value="' +model +'"readonly><br><br></br>';
         
         emailTable= emailTable+ '<table style=\' width:100%;\' cellspacing="0" cellpadding="10pixels"cellspacing="10pixels" bgcolor="#F1F1F1"><tr bgcolor="#FF6700"><th>Asset Class</th><th>Suggested '+ suggested+'</th><th>Customize '+ model+'</th></tr>'; 
         for(let t = 0; t< assets.length; t++)
         { if(parseFloat(assets[t].assetClassValue)>0 || parseFloat(this.state.PreliminaryRiskAssessmentChart[t+1][1])>0 )
            {
               emailTable= emailTable+ '<tr><td style="text-align: center;">'+assets[t].assetClass + '</td>  <td style="text-align: center;" >'+ ((this.state.PreliminaryRiskAssessmentChart[t+1][1]).toString()).substr(0,4) + '%</td>  <td style="text-align: center;" >'+ (assets[t].assetClassValue.toString()).substr(0,4) + '%</td></tr>';
            }
         }
   
         
   
         emailTable= emailTable+ '</table> <br><br> <table style=\' width:100%;\' cellspacing="0" cellpadding="10pixels"cellspacing="10pixels" bgcolor="#F1F1F1"><tr bgcolor="#FF6700"><th>Portfolio</th><th> Return</th><th>Yield</th><th>StdDev</th><th>Sharpe Ratio</th></tr><tr><td style="text-align: center;">'+model+ '(Customized)</td>'
        
         
   
         emailTable= emailTable+ '<td style="text-align: center;">'+parseFloat(r).toFixed(1)+ '%</td>';
         emailTable= emailTable+ '<td style="text-align: center;">'+parseFloat(y).toFixed(1)+ '%</td>';
         emailTable= emailTable+ '<td style="text-align: center;">'+parseFloat(sd).toFixed(1)+ '%</td>';
         emailTable= emailTable+ '<td style="text-align: center;">'+parseFloat(sr).toFixed(1)+ '</td>';
         emailTable= emailTable+ '</tr><tr><td style="text-align: center;">'+suggested+ '(Suggested)</td>';
   
   
         
   
         emailTable= emailTable+ '<td style="text-align: center;">'+parseFloat(this.state.CalculatedModelTypeValues[0]).toFixed(1)+ '%</td>';
         emailTable= emailTable+ '<td style="text-align: center;">'+parseFloat(this.state.CalculatedModelTypeValues[1]).toFixed(1)+ '%</td>';
         emailTable= emailTable+ '<td style="text-align: center;">'+parseFloat(this.state.CalculatedModelTypeValues[2]).toFixed(1)+ '%</td>';
         emailTable= emailTable+ '<td style="text-align: center;">'+parseFloat(this.state.CalculatedModelTypeValues[3]).toFixed(1)+ '</td>';
         emailTable= emailTable+ '</tr></table>';
         
   
         var data = {
            email: this.state.email,
            emailBody: emailTable,
         //   attachment: pdf
         };
          
      
         IPSDataService.SendEmailToUser(data)
         .then(response => 
            {
               this.setState({
                  emailMessage: 'Email sent successfully'
                });
               
             })
      
         .catch(e => 
            {
               this.setState({
               emailMessage: 'Error in email sending.'
            });
               console.log(e);
             });
        
        }
      
      }






               


// /////////////////////////////////////


GenerateCustomPdf(suggested, model, r, y , sd, sr, assets) {


      let title= "Custom Model";
      let pdflistArray=[];
      
      let ReturnArray=[];

      
for(let t = 0; t< assets.length; t++)
      { if(parseFloat(assets[t].assetClassValue)>0 || parseFloat(this.state.PreliminaryRiskAssessmentChart[t+1][1])>0 )
         {
            let pdflist=[];
            pdflist.push(assets[t].assetClass);
            
            pdflist.push((this.state.PreliminaryRiskAssessmentChart[t+1][1].toString()).substr(0,4) + '%');
            pdflist.push((assets[t].assetClassValue.toString()).substr(0,4) + '%');
            
      
            pdflistArray.push(pdflist);

            
         }
      }
       
      let returnlistSuggested=[];
         //returnlistSuggested.push(suggested + "(Suggested)");
         returnlistSuggested.push(suggested);
      

         returnlistSuggested.push(parseFloat(this.state.CalculatedModelTypeValues[0]).toFixed(1)+ '%');
         returnlistSuggested.push(parseFloat(this.state.CalculatedModelTypeValues[1]).toFixed(1)+ '%');
         returnlistSuggested.push(parseFloat(this.state.CalculatedModelTypeValues[2]).toFixed(1)+ '%');
         returnlistSuggested.push(parseFloat(this.state.CalculatedModelTypeValues[3]).toFixed(1));
        
         ReturnArray.push(returnlistSuggested)
      
         
         let returnlist=[];
         //returnlist.push(model + "(Customized)");

         returnlist.push("Customized");
        
           
         returnlist.push(parseFloat(r).toFixed(1)+ '%')
         returnlist.push(parseFloat(y).toFixed(1)+ '%');
         returnlist.push(parseFloat(sd).toFixed(1)+ '%');
         returnlist.push(parseFloat(sr).toFixed(1));
      
         ReturnArray.push(returnlist)

         


         var data = {
            email: this.state.email,
            suggested: suggested,
            model: model,
            title: title,
            pdflistArray:pdflistArray,
            ReturnArray:ReturnArray,
           
         };
          
      
         IPSDataService.GenerateCustomPdfAndSave(data)
         .then(response => 
            {


               console.log(response.data);
               this.setState({
               CustomPDFLink: response.data.path
                     });

                     window.open(this.state.CustomPDFLink, '_blank');
             })
      
         .catch(e => 
            {
               
               console.log(e);
             });
   
   }

////////////////////////////////////////////////////

GeneratePDF(model, returnvalues, assets) 
{
  
if(!this.state.submitted)
{
   this.openModal();
}

else
{
   
   let title= "Suggested Model";
   let pdflistArray=[];

   let ReturnArray=[];


     for(let t = 1; t< assets.length; t++)
   {
      if(parseFloat(assets[t][1])>0)
      {
         let pdflist=[];
      pdflist.push(assets[t][0]);

      pdflist.push((assets[t][1].toString()).substr(0,4) + '%');

      pdflistArray.push(pdflist);
           
   
   }
   }
   
   let returnlist=[];
   returnlist.push(model);
   for(let a=0;a<returnvalues.length; a++)
   { 
      var sign='%';
      if(a==3)
      {
         sign='';
      }
     
      returnlist.push(returnvalues[a].toFixed(1) + sign)
     
   }

   ReturnArray.push(returnlist)
  

    
   

   var data = {


       email: this.state.email,
      model: model,
      title: title,
      pdflistArray:pdflistArray,
      ReturnArray:ReturnArray,
     
   };
    

   IPSDataService.GeneratePdfAndSave(data)
   .then(response => 
      {
         console.log(response.data);

         this.setState({
            SuggestedPDFLink: response.data.path
          });

          window.open(this.state.SuggestedPDFLink, '_blank');
         
          
         
        
       })

   .catch(e => 
      {
         
         console.log(e);
       });
  
  }

}

emailUser(model, returnvalues, assets) 
{
  
if(!this.state.submitted)
{
   this.openModal();
}

else
{
   
   let imgData=''
   // //////////////
   let input = document.getElementById('recommendation-tabtoPDF')

  

   let emailTable=  '<label htmlFor="suggestedModel">Suggested Model: </label> <input type="text" style="border-style : hidden;" name="suggestedModel" value="' +model +'"readonly><br><br></br>';


    emailTable= emailTable+ '<table style=\' width:100%;\' cellspacing="0" cellpadding="10pixels"cellspacing="10pixels" bgcolor="#F1F1F1" ><tr  bgcolor="#FF6700"><th>Asset Class</th><th>Values</th></tr>'; 
   for(let t = 1; t< assets.length; t++)
   {
      if(parseFloat(assets[t][1])>0)
      {
      emailTable= emailTable+ '<tr><td style="text-align: center;">'+assets[t][0] + '</td><td style="text-align: center;">'+ (assets[t][1].toString()).substr(0,4) + '%</td></tr>';
      }
   }
   emailTable= emailTable+ '</table> <br><br> <table style=\' width:100%;\' cellspacing="0" cellpadding="10pixels"cellspacing="10pixels" bgcolor="#F1F1F1"><tr   bgcolor="#FF6700" ><th>Portfolio</th><th> Return</th><th>Yield</th><th>StdDev</th><th>Sharpe Ratio</th></tr><tr><td style="text-align: center;">'+model+ '</td>'
   

   for(let a=0;a<returnvalues.length; a++)
   { 
      var sign='%';
      if(a==3)
      {
         sign='';
      }
      emailTable= emailTable+ '<td style="text-align: center;">'+returnvalues[a].toFixed(1) + sign + '</td>';
     
   }
   emailTable= emailTable+ '</tr></table>';


    
   

   var data = {
      email: this.state.email,
      emailBody: emailTable,
     
   };
    

   IPSDataService.SendEmailToUser(data)
   .then(response => 
      {
         this.setState({
            emailMessage: 'Email sent successfully'
          });
       })

   .catch(e => 
      {
         
         console.log(e);
       });
  
  }

}
 


//  /////////////////////////
printDocument(Divid) {
  
   const input = document.getElementById(Divid);
   html2canvas(input, {   scrollX: 0,
            scrollY: 0})
      
           .then((canvas) => {
      
   var imgData = canvas.toDataURL('image/png');
   var imgWidth = 210; 
   var pageHeight = 250;  
   var imgHeight = canvas.height * imgWidth / canvas.width;
   var heightLeft = imgHeight;
   var doc = new jsPDF('p', 'mm');
   var position = 0;
   
   doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
   heightLeft -= pageHeight;
   
   while (heightLeft >= 0) {
     position = heightLeft - imgHeight;
     doc.addPage();
     doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
     heightLeft -= pageHeight;
   }
   // doc.save( 'file.pdf');
   window.open(doc.output('bloburl'))
});
}
// ////////////////////////////////////




   saveAccount()
    {
   
      document.getElementById("biosuccessMessage").innerHTML= '';
      document.getElementById("bioerrorMessage").innerHTML= '';
      const _AllQuestionsArray=[];
      _AllQuestionsArray.push(this.state.sectionQuestions1_1);
      _AllQuestionsArray.push(this.state.sectionQuestions1_2);
      _AllQuestionsArray.push(this.state.sectionQuestions1_3);
      _AllQuestionsArray.push(this.state.sectionQuestions1_4);
      _AllQuestionsArray.push(this.state.sectionQuestions1_5);
      _AllQuestionsArray.push(this.state.sectionQuestions1_6);
      _AllQuestionsArray.push(this.state.sectionQuestions1_7);
      _AllQuestionsArray.push(this.state.sectionQuestions1_8);
      _AllQuestionsArray.push(this.state.sectionQuestions1_9);
      _AllQuestionsArray.push(this.state.sectionQuestions2_1);

      var data = {
         email: this.state.email,
         fname: this.state.fname,
         contact: this.state.contact,
         lname: this.state.lname,
         QuestionareTypeID : this.state.SelectedQuestionareType , 
         _AllQuestionsArray:  _AllQuestionsArray , 
      };
      console.log("_______________________________");
      console.log(data);
      console.log("_______________________________");
      const reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      if(this.state.email!=="")
      {
         if (reg.test(this.state.email) === false){
               
               document.getElementById("bioerrorMessage").innerHTML= "Invalid email address.";
               return false;
         }

      }
      IPSDataService.signup(data)
         .then(response => 
            {
               
               document.getElementById("biosuccessMessage").innerHTML= 'Details has been saved.';
               console.log(response.data);
               this.setState({
                  submitted: true,
                  showModal:false
                  });
             })

         .catch(e => 
            {
               document.getElementById("bioerrorMessage").innerHTML= e.response.data.message+"Please provide valid data";
               console.log(e);
             });
      }

    fillStateOfLife()
    {  
       this.state.sectionQuestions1_2.map((List, index)=>(
         List.optionsDetails.map((optionsList, optionIndex)=>(
        
         this.setState(({
            LifeCycleState: [...this.state.LifeCycleState, { value: ((this.LifeCycleStateMapping(optionsList.OptionScoreValue))), label: optionsList.OptionText}]
          }))
         
         ))
       ))
    }

    LifeCycleStateMapping(input)
    {
      if(input===3)
      return 25;
      else if(input===2.5)
      return 45;
      else if(input===2)
      return 55;
      else if(input===1.5)
      return 65;
      else if(input===1.25)
      return 75;
      else if(input===1)
      return 85;
      else
      return 85;
    }


         onChangeSelectedLifeCycleState(sectionQuestions1_2, e) 
         {
            this.setState({
               submitted: false
             });
                     let _AllScores=[];
                     let _ALL_Options=[]
            for(let count=0; count<sectionQuestions1_2[0].optionsDetails.length; count++)
            {
               _ALL_Options.push(sectionQuestions1_2[0].optionsDetails[count]);
               _AllScores.push(sectionQuestions1_2[0].optionsDetails[count].OptionScoreValue);
            }
            console.log(sectionQuestions1_2[0].SectionID );

            let _idsAll=[];
            for (let mj = 0; mj < _AllScores.length; mj++) {
               var str1 = sectionQuestions1_2[0].SectionID.concat('1').concat(String(mj));
               _idsAll.push(str1);
            }
          
                     if(e.target.value>=25 && e.target.value<=45)
                     {
                        sectionQuestions1_2[0].givenAnswer=[];
                        sectionQuestions1_2[0].givenAnswer.push(_ALL_Options[0]);
                        sectionQuestions1_2[0].total_score= parseFloat(_AllScores[0]);
                        document.getElementById(_idsAll[0]).checked = true;
                  }

                  else if(e.target.value>=46 && e.target.value<=55)
                  {
                     sectionQuestions1_2[0].givenAnswer=[];
                     sectionQuestions1_2[0].givenAnswer.push(_ALL_Options[1]);
                     sectionQuestions1_2[0].total_score= parseFloat(_AllScores[1]);
                     document.getElementById(_idsAll[1]).checked = true;
                  
               }
               else if(e.target.value>=56 && e.target.value<=65)
               {
                  sectionQuestions1_2[0].givenAnswer=[];
                  sectionQuestions1_2[0].givenAnswer.push(_ALL_Options[2]);
                  sectionQuestions1_2[0].total_score= parseFloat(_AllScores[2]);
                  document.getElementById(_idsAll[2]).checked = true;
            
            }


            else if(e.target.value>=66 && e.target.value<=75)
            {
               sectionQuestions1_2[0].givenAnswer=[];
               sectionQuestions1_2[0].givenAnswer.push(_ALL_Options[3]);
               sectionQuestions1_2[0].total_score= parseFloat(_AllScores[3]);
               document.getElementById(_idsAll[3]).checked = true;
            }
            else if(e.target.value>=76 && e.target.value<85)
            {
               sectionQuestions1_2[0].givenAnswer=[];
               sectionQuestions1_2[0].givenAnswer.push(_ALL_Options[4]);
               sectionQuestions1_2[0].total_score= parseFloat(_AllScores[4]);
               document.getElementById(_idsAll[4]).checked = true;
            }

            else if(e.target.value>=85 )
            {
               sectionQuestions1_2[0].givenAnswer=[];
               sectionQuestions1_2[0].givenAnswer.push(_ALL_Options[5]);
               sectionQuestions1_2[0].total_score= parseFloat(_AllScores[5]);
               document.getElementById(_idsAll[5]).checked = true;
            }
           
            console.log("__________________________________________");
            console.log(sectionQuestions1_2);
            console.log("__________________________________________");

            this.setState({
            SelectedLifeCycleState: e.target.value
            });
  
       }


      onChangeSelectedCapitalSafety(sectionQuestions2_1, e, sectionQuestions2_1_Sliders) {
         this.setState({
            submitted: false
          });

         for(let _t=0; _t<sectionQuestions2_1_Sliders.length; _t++)
         {
            if(e.target.value===sectionQuestions2_1_Sliders[_t].value)
            {
               sectionQuestions2_1[0].givenAnswer=[];
               sectionQuestions2_1[0].givenAnswer.push( sectionQuestions2_1[0].optionsDetails[_t]); 
         sectionQuestions2_1[0].total_score= sectionQuestions2_1[0].optionsDetails[_t].OptionScoreValue; 
            }
         }
         console.log("*****************************")
         console.log(sectionQuestions2_1)
         console.log("*****************************")
         this.setState({
            SelectedCapitalSafety: e.target.value
         });
      }

      onChangeSelectedRiskPreference(sectionQuestions2_1, e, sectionQuestions2_1_Sliders) {
         this.setState({
            submitted: false
          });
         for(let _t=0; _t<sectionQuestions2_1_Sliders.length; _t++)
         {
            if(e.target.value===sectionQuestions2_1_Sliders[_t].value)
            {
               sectionQuestions2_1[1].givenAnswer=[];
               sectionQuestions2_1[1].givenAnswer.push( sectionQuestions2_1[1].optionsDetails[_t]); 
         sectionQuestions2_1[1].total_score= sectionQuestions2_1[1].optionsDetails[_t].OptionScoreValue; 
            }
         }
         console.log("*****************************")
         console.log(sectionQuestions2_1)
         console.log("*****************************")
         this.setState({
            SelectedRiskPreference: e.target.value
         });
        
      }
     
      onChangeSelectedProductPreference(sectionQuestions2_1, e, sectionQuestions2_1_Sliders) {
         this.setState({
            submitted: false
          });
         for(let _t=0; _t<sectionQuestions2_1_Sliders.length; _t++)
         {
            if(e.target.value===sectionQuestions2_1_Sliders[_t].value)
            { 
               sectionQuestions2_1[2].givenAnswer=[];
               sectionQuestions2_1[2].givenAnswer.push( sectionQuestions2_1[2].optionsDetails[_t]); 
         sectionQuestions2_1[2].total_score= sectionQuestions2_1[2].optionsDetails[_t].OptionScoreValue; 
            }
         }
        
         console.log("*****************************")
         console.log(sectionQuestions2_1)
         console.log("*****************************")
         this.setState({
            SelectedProductPreference: e.target.value
         });
      }

      
   

      // //////////////////////////////////
      handleValueChanges(questionNo, sectionQuestions,  optionsDetails, allIDslength, i, e , num, questionTypeCode) 
      {
         this.setState({
            submitted: false,
              });
      
       var section2Id= e.target.id;
       section2Id= section2Id.replace(/.$/,'');
       section2Id=   Number(section2Id);
       let ListSliderValues_1_2=[25, 45, 55, 65, 75, 85 ];
     
       if(section2Id===121)
       {
          let index_= e.target.id.substr(-1);
          index_= Number(index_); 

         this.setState({
            SelectedLifeCycleState: ListSliderValues_1_2[index_]
          });
       }

       if(section2Id===152 &&e.target.checked )
       {
       
         this.setState({
            portfolioSizeCheck: 1,
             dataFillingMessageError:''
          });
       }
      


       
       
         let idsall=[];
         let AllScores=[];
         let ListofAllAnswers=[];
         for (let m = 0; m < allIDslength; m++) 
         {
            var str1 = e.target.id.replace(/.$/,m);
            idsall.push(str1);
            AllScores.push(document.getElementById(str1).value);
         }
   
         let totalscore=0.0;
         if(questionTypeCode===20) 
         {
            for (let x = 0; x <idsall.length; x++) {

               const IDCHECKED = document.getElementById(idsall[x]).checked;
         
               if(IDCHECKED)
               {
                  ListofAllAnswers.push(optionsDetails[x]);
                  totalscore = parseFloat(AllScores[x]) + parseFloat(totalscore);
               }
            }
         sectionQuestions[num].total_score= parseFloat(totalscore);
         sectionQuestions[num].givenAnswer= ListofAllAnswers;
         console.log('############################################################');
         console.log(sectionQuestions);
         console.log('############################################################');
       }
   else
   {
      ListofAllAnswers.push(optionsDetails[i]);
      sectionQuestions[num].givenAnswer = ListofAllAnswers;
      console.log('############################################################');
      console.log(sectionQuestions);
      console.log('############################################################');
      totalscore= e.target.value;
      sectionQuestions[num].total_score= parseFloat(totalscore);
   }


   //////////////////////////// Code for mandatory and default marking//////////////
if(questionNo==7)
{  
   this.setState({
      sectionQuestions1_5_Answered: false  // by default we say no answer was given
         });
   for (let x = 0; x <sectionQuestions.length; x++) 
   {
     
     //alert(JSON.stringify(sectionQuestions[x]));

     if(sectionQuestions[x].givenAnswer.length>=1) // means there is answer in any question of this section
     {
      this.setState({
         sectionQuestions1_5_Answered: true,
            });
            break;
     }

   }

}

 

      }

      ////////////////////////////////////////////////// 
      

      handlePrimaryValueChanges(question, e ,  primaryid) 
      { 
         

            if(e.target.checked)
            {

               if(question==='sectionQuestions1_1')

               {
                  this.setState({
                  Primaryoption1: primaryid,
                     });
                  }

                  else  {
                     this.setState({
                        Primaryoption4: primaryid,
                           });
                        }

                  }
               
            }

            

       

       
         
     
     ////////////////////////////////////////////


 handleValueChangesMulti(questionNo, sectionQuestions,  optionsDetails, allIDslength, i, e , num, questionTypeCode, primaryid) 
 { 
    

   
   this.setState({
      submitted: false,   // means answer of any question is updated. Now we have to submit form again, show popup again.
    });

   let idsall=[];
   let AllScores=[];
   let ListofAllAnswers=[];
   for (let m = 0; m < allIDslength; m++) {
      var str1 = e.target.id.replace(/.$/,m);
      idsall.push(str1);
      AllScores.push(document.getElementById(str1).value);
   }
   let totalscore=0.0;
   if(questionTypeCode===20) {
      if(e.target.checked)
      {
         document.getElementById(primaryid).disabled= false;
      }
      else{
         if(Number(questionNo)===1)
  {
   this.setState({
      Primaryoption1: 0,
         });
  }

  if(Number(questionNo)===4)
  {
   this.setState({
      Primaryoption4: 0,
         });
  }
         

          document.getElementById(primaryid).checked = false ;
         document.getElementById(primaryid).disabled= true;
      }

for (let x = 0; x <idsall.length; x++) {
const IDCHECKED = document.getElementById(idsall[x]).checked;
if(IDCHECKED)
{

   ListofAllAnswers.push(optionsDetails[x]);

   totalscore = parseFloat(AllScores[x]) + parseFloat(totalscore);
}
}

  sectionQuestions[num].givenAnswer= ListofAllAnswers;
  sectionQuestions[num].total_score= parseFloat(totalscore);
  console.log('############################################################');
   console.log(sectionQuestions);
   console.log('############################################################');
 }
else
{
   ListofAllAnswers.push(optionsDetails[i]);
sectionQuestions[num].givenAnswer = ListofAllAnswers;
console.log('############################################################');
   console.log(sectionQuestions);
   console.log('############################################################');
totalscore= e.target.value;
sectionQuestions[num].total_score= parseFloat(totalscore);
}

//////////////////////////// Code for mandatory and default marking//////////////
if(questionNo==1)
{  
   this.setState({
      sectionQuestions2_1_Answered: false  // by default we say no answer was given
         });
   for (let x = 0; x <sectionQuestions.length; x++) 
   {
     
     //alert(JSON.stringify(sectionQuestions[x]));

     if(sectionQuestions[x].givenAnswer.length>=1) // means there is answer in any question of this section
     {
      this.setState({
         sectionQuestions2_1_Answered: true,
            });
            break;
     }

   }

}

if(questionNo==4)
{  //alert(JSON.stringify(sectionQuestions[0].givenAnswer))
   this.setState({
      sectionQuestions1_4_Answered: false  // by default we say no answer was given
         });
  
     
   
     if(sectionQuestions[0].givenAnswer.length>=1) // means there is answer in any question of this section
     {
      this.setState({
         sectionQuestions1_4_Answered: true,
            });
            
     }

   

}

}
////////////////////////////////////////////

submitData()
      {


         var returnTotal=0;
try {
   let firstSectionwithPrimarycheck= this.state.sectionQuestions1_1
   var primary1= this.state.Primaryoption1.slice(-2);
   var outterIndex= primary1.slice(0,1);
  
  

   var innerIndex= primary1.slice(-1);
   innerIndex= Number(innerIndex)+ 1;
  
   
   for(let x= 0; x<firstSectionwithPrimarycheck[outterIndex].givenAnswer.length; x++ )
   {
      
      if (firstSectionwithPrimarycheck[outterIndex].givenAnswer[x].OptionID=== Number(innerIndex) )
      {
var primaryoption = firstSectionwithPrimarycheck[outterIndex].givenAnswer[x].OptionText;

primaryoption = primaryoption + "   (Primary)";

firstSectionwithPrimarycheck[outterIndex].givenAnswer[x].OptionText= primaryoption;


this.setState({
   sectionQuestions1_1: firstSectionwithPrimarycheck
});
      }
      
   }  
} catch (error) 
{
   console.log("Error 1:"+error);
}

/////////////////////////////////////////////
try {
   
   let fourthSectionwithPrimarycheck= this.state.sectionQuestions1_4
   var primary4= this.state.Primaryoption4.slice(-2);
   var _outterIndex= primary4.slice(0,1);
 


   var _innerIndex= primary4.slice(-1);
   _innerIndex= Number(_innerIndex)+ 1;
  
   
   for(let x= 0; x<fourthSectionwithPrimarycheck[_outterIndex].givenAnswer.length; x++ )
   {
      
      if (fourthSectionwithPrimarycheck[_outterIndex].givenAnswer[x].OptionID=== Number(_innerIndex) )
      {
var primaryoption4 = fourthSectionwithPrimarycheck[_outterIndex].givenAnswer[x].OptionText;

primaryoption4 = primaryoption4 + "   (Primary)";

fourthSectionwithPrimarycheck[_outterIndex].givenAnswer[x].OptionText= primaryoption4;


this.setState({
   sectionQuestions1_4: fourthSectionwithPrimarycheck
});
      }
      
   }  
}

catch (error) 
{
   console.log("Error 2:"+error);
}


         
         this.openModal();
         let finalTotalScore=0.0;

         const AllQuestionsArray=[];
         AllQuestionsArray.push(this.state.sectionQuestions1_1);
         AllQuestionsArray.push(this.state.sectionQuestions1_2);
         AllQuestionsArray.push(this.state.sectionQuestions1_3);
         AllQuestionsArray.push(this.state.sectionQuestions1_4);
         AllQuestionsArray.push(this.state.sectionQuestions1_5);
         AllQuestionsArray.push(this.state.sectionQuestions1_6);
         AllQuestionsArray.push(this.state.sectionQuestions1_7);
         AllQuestionsArray.push(this.state.sectionQuestions1_8);
         AllQuestionsArray.push(this.state.sectionQuestions1_9);
         AllQuestionsArray.push(this.state.sectionQuestions2_1);
         
         const portfolioSize= this.state.sectionQuestions1_5[0].givenAnswer[0].SerialNumber;
         console.log("portfolioSize:"+portfolioSize);
         let portfolioSizeValue=0;
         
         if(portfolioSize==='A'|| portfolioSize==='B'){
            portfolioSizeValue=40;
         }
         else if(portfolioSize==='C')
         {
            portfolioSizeValue=60;
         }
         else if(portfolioSize==='D')
         {
            portfolioSizeValue=80;
         }

         let AllAnswers=[];
         let testobj={};
         for(let t = 0; t< AllQuestionsArray.length;t++)
         {
            for(let tt = 0; tt< AllQuestionsArray[t].length;tt++)
               {
                  finalTotalScore+=AllQuestionsArray[t][tt].total_score;
                  testobj={};
                  testobj['GivenAnswer']=[]; 
                  testobj['Question']=AllQuestionsArray[t][tt].QuestionID;
                  testobj['options']=AllQuestionsArray[t][tt].optionsDetails;
                  testobj['total_score']=AllQuestionsArray[t][tt].total_score;
                  testobj['GivenAnswer'].push(AllQuestionsArray[t][tt].givenAnswer);
                  AllAnswers.push(  testobj );
               }
         }

         console.log("get Model Types as per scores:"+finalTotalScore+" and portfolioSizeValue:"+portfolioSizeValue);
         IPSDataService.getModelTypes(finalTotalScore,this.state.SelectedQuestionareType, portfolioSizeValue)
         .then(response => {
            
         console.log(response);
         
         const modelTypeNAme= response['data'][0].name;
         const _return =   response['data'][0].returnValue;
         returnTotal=_return;
         const _yield =   response['data'][0].yield;
         const _standardDev =   response['data'][0].standardDeviation;
         const _sharpeRatio =   response['data'][0].sharpeRatio;
         let modelvalues= [];
         modelvalues.push(_return);
         modelvalues.push(_yield);
         modelvalues.push(_standardDev);
         modelvalues.push(_sharpeRatio);

         /////////////////////////100 Dollar Chart///////////////////
         console.log("100 Dollar Chart:");
         let _100DollarChartSample=[["Future Year",  "Portfolio Value"]];
         var startYear=1;
         var endYear=10;
         var totalReturn=100;
         for(let i=startYear; i<=endYear; i++)
         {
             totalReturn=totalReturn+(totalReturn*(parseFloat(returnTotal/100)));
             let sample=[];
            sample.push(i.toString());
            sample.push(parseFloat(totalReturn));
            _100DollarChartSample.push(sample);

            
         }

         console.log(_100DollarChartSample);

        

         let sampleArray = ['Asset Class', '%'];
         let assetClassArray=[];
         assetClassArray.push(sampleArray);

         for(let i=0; i<response['data'].length; i++)
         {
            let sample=[];
            sample.push(response['data'][i].assetClass);
            sample.push(parseFloat(response['data'][i].assetClassValue));
            assetClassArray.push(sample);
         }
        
         console.log("Classes data for calculated model:"+assetClassArray);

         this.setState({
            CalculatedModelType : modelTypeNAme,
            Custom_Model:modelTypeNAme,
            CalculatedModelTypeValues: modelvalues, 
            PreliminaryRiskAssessmentChart:assetClassArray ,
            _100DollarChart :_100DollarChartSample
         });


         /////////////////////////////////////Now get all models of portfolioSizeValue/////////////////////////
         console.log("Now get all models of portfolioSizeValue: "+ portfolioSizeValue)
         IPSDataService.getAllModelTypes(this.state.SelectedQuestionareType, portfolioSizeValue)
         .then(response => {
            
            
         console.log(response);

         

         let CustomModelArray = [];
         let listOfAllModels= [];
         let ALL_MODEL_DETAILS =[];
         

         for(let i=0; i<response['data'].length; i++)
         {
            listOfAllModels.push(response['data'][i].name);
            ALL_MODEL_DETAILS.push(response['data'][i]);
            
            if(this.state.CalculatedModelType===response['data'][i].name) // initially it will have Calculated/Suggested model
            {
            CustomModelArray.push(response['data'][i]);
            }
         }

         console.log("Initial custom model:");
         console.log(CustomModelArray);

         const DifferentModels= [...new Set(listOfAllModels)];

         console.log("All models:");
         console.log(DifferentModels);

         
         let _sampleArray = ['Asset Class', '%'];
         let CustomAssetClassArray=[];
         CustomAssetClassArray.push(_sampleArray);

         for(let i=0; i<response['data'].length; i++)
         {
            if(this.state.CalculatedModelType===response['data'][i].name)
            {
            let sample=[];
            sample.push(response['data'][i].assetClass);
            sample.push(parseFloat(response['data'][i].assetClassValue));
            CustomAssetClassArray.push(sample);
            }
         }


         this.setState({
            
            _ALL_Models: DifferentModels,
            ALL_MODEL_DETAILS_Array: ALL_MODEL_DETAILS,
            Custom_ModelArray : CustomModelArray,
            CustomModelChart: CustomAssetClassArray,
         });
        
        
         
         })
         .catch(e => {
            console.log("Error in Now get all models of portfolioSizeValue, Error: "+e);
         });
        

         
         })
         .catch(e => {
            console.log("Error in get Model Types as per scores, Error: "+e);
         });

         
    
      }


      /////////////////////////////////////////

// /////////////////////////////
radiobuttonchange(model, e)
{
   let n = this.state.Custom_ModelArray.length;
let ChangedmodelArray=[];
let reloadbtnTemp=true;

let sum = 0;
console.log("All Models:");
console.log(this.state.ALL_MODEL_DETAILS_Array);

         for(let i=0; i<this.state.ALL_MODEL_DETAILS_Array.length; i++)
         {
            if(model===this.state.ALL_MODEL_DETAILS_Array[i].name)
            {

               

         
               ChangedmodelArray.push(this.state.ALL_MODEL_DETAILS_Array[i]);
            }
         }

         // ///////////////////////
         let _sampleArray = ['Asset Class', '%'];
         let CustomAssetClassChartArray=[];
         CustomAssetClassChartArray.push(_sampleArray);

         for(let i=0; i<ChangedmodelArray.length; i++)
         {
            let sample=[];
            sample.push(ChangedmodelArray[i].assetClass);
            sample.push(parseFloat(ChangedmodelArray[i].assetClassValue));
            CustomAssetClassChartArray.push(sample);
            
         }



         this.setState({
            CustomModelChart : CustomAssetClassChartArray,
            Custom_Model:model,
            
            Custom_ModelArray : ChangedmodelArray,
         });


}


newCustomValues()
{

  
let reloadbtnTemp=true;
let sum = 0;
         for(let j=0; j<this.state.Custom_ModelArray.length; j++)
         {
        
            
         sum=parseFloat(sum)+parseFloat((document.getElementById(String("customizedFieldTDValue"+String(j))).value.toString()).substr(0,4));
              
        
         }
         console.log("totalSum:"+sum)
        
         if(parseFloat(sum)>=parseFloat(99.5) && parseFloat(sum)<=parseFloat(100))
         {
            reloadbtnTemp=true;
            
         }
         else
         {  
            reloadbtnTemp=false;
         }

         this.setState({
            sumOfWeights:sum,
            reloadbtn: reloadbtnTemp,
            needreloadbtnclick:true
         });
         
       
}
// ///////////////////////////////////////////////////////////////
handleOtherModelTypeChanges( model, e ) 
{ 

    this.radiobuttonchange(model, e);



    setTimeout(

      
      function() {
         this.newCustomValues();
      }
      .bind(this),
      1000
    );
   
   
}

// //////////////////////////////////////////////////////////////////////////////////////////////////////////
reloadData(e)
{

   

   IPSDataService.getCustomizedRetunValues()
         .then(response => {

            
            console.log("______________Current Custom_ModelArray _________________");
            console.log(this.state.Custom_ModelArray);
            console.log("__________________________________________");
         
////////////////////////////
 
 let _risk_=0.0;
 let __Return__=0.0;
 let __Yield__=0.0;
 let FI_EM = [];
 let FI_MUNI  =[];
 let FI_TIPS  =[];
 let FI_US  =[];
 let EQ_US  =[];
 let EQ_KSA  =[];
 let EQ_EM  =[];
 let HF_ALL  =[];
 let CM_EGY  =[];
 let CM_MTL  =[];
 let CM_NON_MTL  =[];
 let CM_GLD  =[];
 let REIT_US  =[];
 let MMF_US  =[];
 let PE_GRTH  =[];
 let PE_VC =[];
 let PD =[];
 let RE_DEV= [];
 //let LEV_ALL=[];
 let covArray=[];


  for(let nn=0; nn<response['data'].length; nn++)
  {
    let  _cov_=0.0;

      FI_EM.push(Number(response['data'][nn].FI_EM)*12);
      FI_MUNI.push(Number(response['data'][nn].FI_MUNI)*12);
      FI_TIPS.push(Number(response['data'][nn].FI_TIPS)*12);
      FI_US.push(Number(response['data'][nn].FI_US)*12);
      EQ_US.push(Number(response['data'][nn].EQ_US)*12);
      EQ_KSA.push(Number(response['data'][nn].EQ_KSA)*12); 
      EQ_EM.push(Number(response['data'][nn].EQ_EM)*12);  
      HF_ALL.push(Number(response['data'][nn].HF_ALL)*12);  
      CM_EGY.push(Number(response['data'][nn].CM_EGY)*12);  
      CM_MTL.push(Number(response['data'][nn].CM_MTL)*12);  
      CM_NON_MTL.push(Number(response['data'][nn].CM_NON_MTL)*12); 
      CM_GLD.push(Number(response['data'][nn].CM_GLD)*12);  
      REIT_US.push(Number(response['data'][nn].REIT_US)*12);  
      MMF_US.push(Number(response['data'][nn].MMF_US)*12);  
      PE_GRTH.push(Number(response['data'][nn].PE_GRTH)*12);  
      PE_VC.push(Number(response['data'][nn].PE_VC)*12); 
      PD.push(Number(response['data'][nn].PD)*12); 
      RE_DEV.push(Number(response['data'][nn].RE_DEV)*12);
      //LEV_ALL.push(Number(response['data'][nn].LEV_ALL)*12);
  



  _cov_ =  _cov_+   ((Number(this.state.Custom_ModelArray[0].assetClassValue))/100) *(Number(FI_EM[nn])) ;
  
  _cov_ =  _cov_ +   ((Number(this.state.Custom_ModelArray[1].assetClassValue))/100) *(Number(FI_MUNI[nn])) ;
  
  _cov_ =  _cov_+    ((Number(this.state.Custom_ModelArray[2].assetClassValue))/100) *(Number(FI_TIPS[nn])) ;
  
  _cov_ =  _cov_+ ((Number(this.state.Custom_ModelArray[3].assetClassValue))/100) *(Number(FI_US[nn])) ;
  
  _cov_ =  _cov_+  ((Number(this.state.Custom_ModelArray[4].assetClassValue))/100) *(Number(EQ_US[nn])) ;
  _cov_ =  _cov_+ ((Number(this.state.Custom_ModelArray[5].assetClassValue))/100) *(Number(EQ_KSA[nn])) ;
  _cov_ =  _cov_+   ((Number(this.state.Custom_ModelArray[6].assetClassValue))/100) *(Number(EQ_EM[nn])) ;
  _cov_ =  _cov_+  ((Number(this.state.Custom_ModelArray[7].assetClassValue))/100) *(Number(HF_ALL[nn])) ;
  _cov_ =  _cov_+  ((Number(this.state.Custom_ModelArray[8].assetClassValue))/100) *(Number(CM_EGY[nn])) ;
  _cov_ =  _cov_+ ((Number(this.state.Custom_ModelArray[9].assetClassValue))/100) *(Number(CM_MTL[nn])) ;
  _cov_ =  _cov_+   ((Number(this.state.Custom_ModelArray[10].assetClassValue))/100) *(Number(CM_NON_MTL[nn])) ;
  _cov_ =  _cov_+  ((Number(this.state.Custom_ModelArray[11].assetClassValue))/100) *(Number(CM_GLD[nn])) ;
  _cov_ =  _cov_+   ((Number(this.state.Custom_ModelArray[12].assetClassValue))/100) *(Number(REIT_US[nn])) ;
  _cov_ =  _cov_+   ((Number(this.state.Custom_ModelArray[13].assetClassValue))/100) *(Number(MMF_US[nn])) ;
  _cov_ =  _cov_+   ((Number(this.state.Custom_ModelArray[14].assetClassValue))/100) *(Number(PE_GRTH[nn])) ;
  _cov_ =  _cov_+   ((Number(this.state.Custom_ModelArray[15].assetClassValue))/100) *(Number(PE_VC[nn])) 
  _cov_ =  _cov_+   ((Number(this.state.Custom_ModelArray[16].assetClassValue))/100) *(Number(PD[nn])) ;
  _cov_ =  _cov_+  ((Number(this.state.Custom_ModelArray[17].assetClassValue))/100) *(Number(RE_DEV[nn])) ;

  //_cov_ =  _cov_+  ((Number(this.state.Custom_ModelArray[18].assetClassValue))/100) *(Number(LEV_ALL[nn]));
 

  
      _risk_= _risk_+  _cov_* ((Number(this.state.Custom_ModelArray[nn].assetClassValue))/100);
       covArray.push(_cov_);
     __Return__=__Return__+  ((Number(this.state.Custom_ModelArray[nn].assetClassValue))/100) * (Number(response['data'][nn].custom_mu))*12;
     __Yield__=__Yield__+  ((Number(this.state.Custom_ModelArray[nn].assetClassValue))/100) * (Number(response['data'][nn].custom_yield));
     
         }
         
// ///////////////////
let __sharpeRatio__= 0.0;
let __standardDev__=0.0;
__Return__=__Return__*100;
     __Yield__=__Yield__*100;

__sharpeRatio__=  ((Number(__Return__ ))/ (Math.sqrt( _risk_ )))/100;
__standardDev__= (Math.sqrt( _risk_ ))*100 

// alert(__Return__+ "   is the return value")
console.log(__Return__ + " is the return value");
// alert(__Yield__ + "   is the yield value")
console.log(__Yield__ +"   is the yield value");





let final_CustomizedArray= this.state.Custom_ModelArray;
final_CustomizedArray[0].returnValue= parseFloat(__Return__).toFixed(1);
final_CustomizedArray[0].yield= parseFloat(__Yield__).toFixed(1);
final_CustomizedArray[0].standardDeviation= parseFloat(__standardDev__).toFixed(1);
final_CustomizedArray[0].sharpeRatio= parseFloat(__sharpeRatio__).toFixed(1);

        
         this.setState({
           
            Custom_ModelArray: final_CustomizedArray, 
            emailMessage:'',
            needreloadbtnclick:false
         });
         })
         .catch(e => {
            console.log(e);
         });
   

}

// ////////////////////////////////////////////////
handleCustomClassChanges(index,className,e)
{
  this.handleCustomClassChangesTableData(index,className,e);
  
setTimeout(

      
   function() {
      this.newCustomValues();
   }
   .bind(this),
   1000
 );
}

// //////////////////////////////////////////////////////
handleCustomClassChangesTableData(index,className,e)
{
  
   let arrayTemp=this.state.Custom_ModelArray;
   let totalSum=parseFloat(0);
   // let reloadbtnTemp=true;
   let _sampleArray = ['Asset Class', '%'];
   let CustomAssetClassArray=[];
   CustomAssetClassArray.push(_sampleArray);
  /////////// End of for required data for custome model chart////////


   for(let i=0; i<arrayTemp.length; i++)
         {
            if(className==arrayTemp[i].assetClass)
            {
               arrayTemp[i].assetClassValue=e.target.value
            }
            totalSum=parseFloat(totalSum)+parseFloat(arrayTemp[i].assetClassValue);
           
            /////////// for required data for custome model chart////////
            let sample=[];
            sample.push(arrayTemp[i].assetClass);
            sample.push(parseFloat(arrayTemp[i].assetClassValue));
            CustomAssetClassArray.push(sample);
         }

         
      

         this.setState({
            Custom_ModelArray : arrayTemp,
            // reloadbtn: reloadbtnTemp,
            CustomModelChart : CustomAssetClassArray
         });
        

}

// ///////////////////////////////

handleTypesOfQuestionaresListChanges(id,e)
{  
    this.setState({
        sectionQuestions1_1: [],
        sectionQuestions1_2:[],
        sectionQuestions1_3:[],
        sectionQuestions1_4:[],
        sectionQuestions1_5:[],
        sectionQuestions1_6:[],
        sectionQuestions1_7:[],
        sectionQuestions1_8:[],
        sectionQuestions1_9:[],
        sectionQuestions2_1:[],
     });
        var QuestionareType=id;
        this.retrievesectionQuestionsListDetails(11,QuestionareType,'sectionQuestions1_1');
        this.retrievesectionQuestionsListDetails(12,QuestionareType,'sectionQuestions1_2');
        this.retrievesectionQuestionsListDetails(13,QuestionareType,'sectionQuestions1_3');
        this.retrievesectionQuestionsListDetails(14,QuestionareType,'sectionQuestions1_4');
        this.retrievesectionQuestionsListDetails(15,QuestionareType,'sectionQuestions1_5');
        this.retrievesectionQuestionsListDetails(16,QuestionareType,'sectionQuestions1_6');
        this.retrievesectionQuestionsListDetails(17,QuestionareType,'sectionQuestions1_7');
        this.retrievesectionQuestionsListDetails(18,QuestionareType,'sectionQuestions1_8');
        this.retrievesectionQuestionsListDetails(19,QuestionareType,'sectionQuestions1_9');
        this.retrievesectionQuestionsListDetails(21,QuestionareType,'sectionQuestions2_1'); 
        this.setState({
         SelectedQuestionareType: id
        });
}

retrieveTypesOfQuestionares() {
   IPSDataService.getTypesOfQuestionares()
     .then(response => {
       this.setState({
         TypesOfQuestionaresList: response.data
       });
       console.log(response.data);

       document.getElementById('InvestorType10').click(); // click on Family/Office

     })
     .catch(e => {
       console.log(e);
     });
 }

 retrievesectionQuestionsListDetails(SectionID,QuestionareType,QuestionSection) {   
    
   IPSDataService.getSectionQuestionsListNew(SectionID,QuestionareType)

     .then(response => {
       var questionsData = [];
       var options=[];
       var CurrentQuestionID=response.data[0]["QuestionID"];
       var j=0;
       var k=0;
       for(var i=0;i<response.data.length;i++)
       { 
         if(i+1===response.data.length) // check if it last index, just push all to questionsData array and break
         { 
            options[j++]={OptionID:response.data[i]["OptionID"],OptionText:response.data[i]["OptionText"],SerialNumber:response.data[i]["SerialNumber"],OptionScoreValue:response.data[i]["OptionScoreValue"],OptionIsDefault:response.data[i]["OptionIsDefault"]};
            questionsData[k]={SectionID:response.data[i]['SectionID'],
                              QuestionID:response.data[i]['QuestionID'],
                              SerialNumber: response.data[i]['SerialNumber'],
                              QuestionText:response.data[i]["QuestionText"],
                              SuggestionType:response.data[i]['SuggestionType'],
                              SuggestionValue:response.data[i]['SuggestionValue'],
                              illustration: response.data[i]['Illustration'],
                              CommentHeading:response.data[i]['CommentHeading'],
                              HasComments:response.data[i]['HasComments'],
                              QuestionTypeDescription:response.data[i]['QuestionTypeDescription'],
                              QuestionTypeCode:response.data[i]['QuestionTypeCode'],
                              givenAnswer:[],
                              givenCommnets:"", 
                              total_score:0.0, 
                              optionsDetails:options}; 
            break;
         }
         else
         {
            
            if(CurrentQuestionID!==response.data[i]["QuestionID"])
            {  
               
               questionsData[k++]={SectionID:response.data[i-1]['SectionID'],
                                   QuestionID:response.data[i-1]['QuestionID'],
                                   SerialNumber: response.data[i-1]['SerialNumber'],
                                   QuestionText:response.data[i-1]["QuestionText"],
                                   SuggestionType:response.data[i-1]['SuggestionType'],
                                   SuggestionValue:response.data[i-1]['SuggestionValue'],
                                   illustration: response.data[i-1]['Illustration'],
                                   CommentHeading:response.data[i-1]['CommentHeading'],
                                   HasComments:response.data[i-1]['HasComments'],
                                   QuestionTypeDescription:response.data[i-1]['QuestionTypeDescription'],
                                   QuestionTypeCode:response.data[i-1]['QuestionTypeCode'],
                                   givenAnswer:[],
                                   givenCommnets:"", 
                                   total_score:0.0, 
                                   optionsDetails:options}; 
               j=0;
               options=[];
            }
         }
         CurrentQuestionID=response.data[i]["QuestionID"];
         options[j++]={OptionID:response.data[i]["OptionID"],OptionText:response.data[i]["OptionText"],SerialNumber:response.data[i]["SerialNumber"],OptionScoreValue:response.data[i]["OptionScoreValue"],OptionIsDefault:response.data[i]["OptionIsDefault"]};
  
       }
         this.setState({
            [QuestionSection]: questionsData,  // placing [] around string will refer to variable of same name e.g 'sectionQuestions1_1' we pass and now [sectionQuestions1_1] will refer to sectionQuestions1_1 variable
       });

       if(QuestionSection==="sectionQuestions1_2")
       {
         this.fillStateOfLife();
       }
      
     })
     .catch(e => {
       console.log(e);
     });
 }

 tabClick()
 {

   this.setState({
      showProgressBar: true,
      emailMessage:'' 
   });

   setTimeout(

      
      function() {
         this.setState({showProgressBar: false});
      }
      .bind(this),
      3000
    );
    
  
    
 }
 //////////////////////////////////

    render() {
       
        const { _100DollarChart, PreliminaryRiskAssessmentChart,CalculatedModelType,Custom_Model,Custom_ModelArray,CustomModelChart,_ALL_Models, ALL_MODEL_DETAILS_Array, CalculatedModelTypeValues, TypesOfQuestionaresList,LifeCycleState,SelectedLifeCycleState,sectionQuestions2_1_Sliders,SelectedCapitalSafety,SelectedRiskPreference,SelectedProductPreference, knowledgeLevelList,portfolioSizeList,stateOfLifeList, dependents,sectionQuestions1_0,sectionQuestions1_1,sectionQuestions1_2,sectionQuestions1_3,sectionQuestions1_4,sectionQuestions1_5,sectionQuestions1_6,sectionQuestions1_7,sectionQuestions1_8,sectionQuestions1_9,sectionQuestions2_1,dataFillingMessageError,dataFillingMessageSuccess } = this.state;
        
        const countryList = ["Afghanistan",	"Albania",	"Algeria",	"American Samoa",	"Andorra",	"Angola",	"Anguilla",	"Antarctica",	"Antigua and Barbuda",	"Argentina",	"Armenia",	"Aruba",	"Australia",	"Austria",	"Azerbaijan",	"Bahamas",	"Bahrain",	"Bangladesh",	"Barbados",	"Belarus",	"Belgium",	"Belize",	"Benin",	"Bermuda",	"Bhutan",	"Bolivia (Plurinational State of)",	"Bonaire, Sint Eustatius and Saba",	"Bosnia and Herzegovina",	"Botswana",	"Bouvet Island",	"Brazil",	"British Indian Ocean Territory",	"Brunei Darussalam",	"Bulgaria",	"Burkina Faso",	"Burundi",	"Cabo Verde",	"Cambodia",	"Cameroon",	"Canada",	"Cayman Islands",	"Central African Republic",	"Chad",	"Chile",	"China",	"Christmas Island",	"Cocos (Keeling) Islands",	"Colombia",	"Comoros",	"Congo (the Democratic Republic of the)",	"Congo",	"Cook Islands",	"Costa Rica",	"Croatia",	"Cuba",	"Curaçao",	"Cyprus",	"Czechia",	"Côte d'Ivoire",	"Denmark",	"Djibouti",	"Dominica",	"Dominican Republic",	"Ecuador",	"Egypt",	"El Salvador",	"Equatorial Guinea",	"Eritrea",	"Estonia",	"Eswatini",	"Ethiopia",	"Falkland Islands [Malvinas]",	"Faroe Islands",	"Fiji",	"Finland",	"France",	"French Guiana",	"French Polynesia",	"French Southern Territories",	"Gabon",	"Gambia",	"Georgia",	"Germany",	"Ghana",	"Gibraltar",	"Greece",	"Greenland",	"Grenada",	"Guadeloupe",	"Guam",	"Guatemala",	"Guernsey",	"Guinea",	"Guinea-Bissau",	"Guyana",	"Haiti",	"Heard Island and McDonald Islands",	"Holy See",	"Honduras",	"Hong Kong",	"Hungary",	"Iceland",	"India",	"Indonesia",	"Iran (Islamic Republic of)",	"Iraq",	"Ireland",	"Isle of Man",	"Israel",	"Italy",	"Jamaica",	"Japan",	"Jersey",	"Jordan",	"Kazakhstan",	"Kenya",	"Kiribati",	"Korea (the Democratic People's Republic of)",	"Korea (the Republic of)",	"Kuwait",	"Kyrgyzstan",	"Lao People's Democratic Republic",	"Latvia",	"Lebanon",	"Lesotho",	"Liberia",	"Libya",	"Liechtenstein",	"Lithuania",	"Luxembourg",	"Macao",	"Madagascar",	"Malawi",	"Malaysia",	"Maldives",	"Mali",	"Malta",	"Marshall Islands",	"Martinique",	"Mauritania",	"Mauritius",	"Mayotte",	"Mexico",	"Micronesia (Federated States of)",	"Moldova (the Republic of)",	"Monaco",	"Mongolia",	"Montenegro",	"Montserrat",	"Morocco",	"Mozambique",	"Myanmar",	"Namibia",	"Nauru",	"Nepal",	"Netherlands",	"New Caledonia",	"New Zealand",	"Nicaragua",	"Niger",	"Nigeria",	"Niue",	"Norfolk Island",	"Northern Mariana Islands",	"Norway",	"Oman",	"Pakistan",	"Palau",	"Palestine, State of",	"Panama",	"Papua New Guinea",	"Paraguay",	"Peru",	"Philippines",	"Pitcairn",	"Poland",	"Portugal",	"Puerto Rico",	"Qatar",	"Republic of North Macedonia",	"Romania",	"Russian Federation",	"Rwanda",	"Réunion",	"Saint Barthélemy",	"Saint Helena, Ascension and Tristan da Cunha",	"Saint Kitts and Nevis",	"Saint Lucia",	"Saint Martin (French part)",	"Saint Pierre and Miquelon",	"Saint Vincent and the Grenadines",	"Samoa",	"San Marino",	"Sao Tome and Principe",	"Saudi Arabia",	"Senegal",	"Serbia",	"Seychelles",	"Sierra Leone",	"Singapore",	"Sint Maarten (Dutch part)",	"Slovakia",	"Slovenia",	"Solomon Islands",	"Somalia",	"South Africa",	"South Georgia and the South Sandwich Islands",	"South Sudan",	"Spain",	"Sri Lanka",	"Sudan",	"Suriname",	"Svalbard and Jan Mayen",	"Sweden",	"Switzerland",	"Syrian Arab Republic",	"Taiwan",	"Tajikistan",	"Tanzania, United Republic of",	"Thailand",	"Timor-Leste",	"Togo",	"Tokelau",	"Tonga",	"Trinidad and Tobago",	"Tunisia",	"Turkey",	"Turkmenistan",	"Turks and Caicos Islands",	"Tuvalu",	"Uganda",	"Ukraine",	"United Arab Emirates",	"United Kingdom of Great Britain and Northern Ireland",	"United States Minor Outlying Islands",	"United States of America",	"Uruguay",	"Uzbekistan",	"Vanuatu",	"Venezuela (Bolivarian Republic of)",	"Viet Nam",	"Virgin Islands (British)",	"Virgin Islands (U.S.)",	"Wallis and Futuna",	"Western Sahara",	"Yemen",	"Zambia",	"Zimbabwe",	"Åland Islands"];
        
        let legendPosition='bottom'
        if(this.state.screenWidth>=767)
        {
         legendPosition='left'
        }
       const pieOptions = {
         title: '',
         pieHole: 0.5,
         legend: { position: legendPosition, fontSize: 10, }
       }

        return (
   
      <div>
         <div className="clearfix"></div>
      <ReactTooltip />   
         <div>
         <section>
            <div className="center-wrapper">

    

               {/* ////////////////// STEP 0  ///////////////////*/}
               <div id ="firstStep" className="main-container card investorType">
                  <div className="row">
                  <div className="innerHeadingSection">
                     <h4>A thorough risk assessment is the cornerstone of any successful investment strategy</h4>
                     <h6>Help us understand your unique investment needs</h6>
                  </div>

                     <div className="col-md-7 col-xs-12">
                        
                        <div className="card-title"> <h3></h3>Investor type: </div>
                        <div className="row" style={{marginTop:'2.5rem'}}>
                           { TypesOfQuestionaresList && TypesOfQuestionaresList!="Loading options" && TypesOfQuestionaresList.length>0? TypesOfQuestionaresList.map((optionsList, optionIndex)=>(
                           <div className="col-md-6" style={{marginBottom:'10px'}}>
                              <input type="radio" id={"InvestorType"+String(optionsList.ID+String(optionIndex))} 
                                 name="select" value={optionsList.ID}  
                                 onChange={e => this.handleTypesOfQuestionaresListChanges(optionsList.ID, e)}/>
                              <label className="investorType_label" htmlFor={"InvestorType"+String(optionsList.ID+String(optionIndex))}>
                                 <div className="row">
                                    <div className=" col-md-8 col-lg-8 col-xs-8" style={{padding:'0px'}}>
                                       <div className="card-title" style={{marginTop:"0.75rem"}}>
                                          {optionsList.Title}
                                       </div>
                                    </div>
                                    <div className=" col-md-3 col-lg-3 col-xs-3">
                                       <img alt = "Investor type" src={optionsList.Title==="Family/Office"?"/assets/personal.svg":"/assets/corporate.svg"} width="50px" height="50px"/>
                                    </div>
                                 </div>
                              </label>
                           </div>
                           )): ""
                           
                           }
                       

                        {TypesOfQuestionaresList=="Loading options" ? 
                        <p> Loading options....</p> : ''


                        }
                        </div>
                     </div>
                     <div className="col-md-5 col-xs-12">
                        <div className="card right-side-card">
                           {/*<img alt = "Info" src="assets/message.svg" width="25px" height="25px" /> */}
                           <div className="right-card-text" style={{marginTop:'0.5rem',lineHeight:"1.25"}}>
                           To define and develop an effective investment strategy, we need your support to clearly understand your risk and return objectives as well as your border circumstances.<br/><br/> This brief questionnaire will help us develop an understanding of your investment needs and preferences and will be used to curate a bespoke portfolio for you. 
                           </div>
                        </div>
                        <button type="submit" disabled={ this.state.policycheck==false?"disabled":""} className="btn next-btn" id="submit-button-of-investor-type">Next</button>
                        
                        <div className="col-md-12 col-xs-12" style={{textAlign:"center"}} >
                           <br/>
                        <a  onClick={e => this.openModalSkipSteps()} style={{color:'rgb(0, 120, 212)',border:'3px solid #67707D', padding:'5px 20px', boxShadow:'0px 0px 20px #67707D', marginBottom:'10px'}}  class="btn btn-sm">Skip Steps</a>
                        </div>
                     </div>
                  </div>
                  <div className="form-check" style={{paddingLeft:'0px'}}>
          <input style={{marginLeft:'0px'}} onChange={this.onChangePolicyCheck} defaultChecked={this.state.policycheck} type="checkbox" name="policycheck" className="form-check-input"  id="policycheck"/ >
          <label className="form-check-label" htmlFor="policycheck"   style={{display:'inline'}}>I agree with </label><a onClick={e => this.openModalTandC()} style={{color:"#0078D4"}} target="_blank" >Terms & Conditions</a> 
          <p style={{color:'red', paddingLeft:'3px'}}>{ this.state.policycheck==false? "Please click agree with Terms & Conditions":""}</p>
        </div>
               </div>
               
               {/* ///////////////  END OF STEP 0////////////*/}
               
            
               {/* ////////////////// STEP 1  ///////////////////*/}
               <div className="main-container card">
                  <div className="row">
                  <div className="innerHeadingSection">
                     <h4>{this.state.sectionHeading1}</h4>
                     <h6></h6>
                  </div>
                     <div className="col-md-7">
                        <div id="questions-container">
                           { sectionQuestions1_1 && sectionQuestions1_1.length>0? sectionQuestions1_1.map((List, index)=>(
                           <div className="card questions-card">
                              <div data-toggle="collapse" className="collapse_title" data-target={"#collapse"+index}>
                                 <i className="icon-action fa fa-chevron-down"></i>
                                 <div className="question-div" data-value={List.QuestionText}>{List.QuestionText}</div>
                                 {/*<img alt = "Info" src="assets/message.svg" width="17px" height="17px" /> */}
                              </div>
                              <div  className={index===0?"filter-content collapse show":"filter-content collapse"} id={"collapse"+index}>
                              <div className="card-body"  style={{paddingLeft:'0.5rem',  paddingBottom:'0', display: 'block'}}>
                              {List.optionsDetails  &&  List.optionsDetails.length > 0 ? List.optionsDetails.map((optionsList, optionIndex) => (
                              <div className="ps-options-wrapper">
                                 <input type="checkbox" id={String(List.QuestionID+String(optionIndex))}  onChange={e => this.handleValueChangesMulti('1',  sectionQuestions1_1, List.optionsDetails,List.optionsDetails.length, optionIndex, e, index, List.QuestionTypeCode, "pr0".concat(String(List.SectionID).concat(String(index)).concat(String(optionIndex))))} name="ps_checkboxaa" value={optionsList.OptionScoreValue}    className="ps-checkbox"/>
                                 <label htmlFor={String(List.QuestionID+String(optionIndex))}>
                                    <div className="option-card">
                                       <i className="fa fa-check"  style={{marginRight:'0.5rem',   display: 'none'}}></i>
                                       {optionsList.OptionText}    

                                       <input type="radio" 
                                          id={"pr0".concat(String(List.SectionID).concat(String(index)).concat(String(optionIndex)))}
                                          disabled
                                          onChange={e => this.handlePrimaryValueChanges( "sectionQuestions1_1",  e,  "pr0".concat(String(List.SectionID).concat(String(index)).concat(String(optionIndex))))}
                                          name={"ps_radio".concat("first").concat(String(List.SectionID))} value="primary" className="ps-radio" /> 
                                 <label htmlFor={"pr0".concat(String(List.SectionID).concat(String(index)).concat(String(optionIndex)))}>
                                 <img alt = "" src="assets/primary.svg"  className="ps-tag" id="primary-icon" wwidth="20px" height="20px" />
                                 </label>
                                 <div hidden>
                                 <input type="radio" id={"se0".concat(String(index).concat(String(optionIndex)))} name={"ps_radio".concat("first").concat(String(index)).concat(String(optionIndex))} value="secondary" className="ps-radio"/> 
                                 <label htmlFor={"se0".concat(String(index).concat(String(optionIndex)))}>
                                 <img alt = "" src="assets/secondary.svg" className="ps-tag"  id="secondary-icon" width="18px" height="18px"/>
                                 </label>
                                 </div>
                                 </div>
                                 </label>
                              </div>
                              )): 
                              <p> No options found.</p>
                              }
                           </div>
                        </div>
                     </div>
                     )): 
                     <p> No question found.</p>
                     }  
                  </div>
               </div>
               <div className="col-md-5" >
                  <div className="card right-side-card">
                     {/*<img alt = "Info" src="assets/message.svg" width="25px" height="25px" /> */}
                     <div className="right-card-text" style={{marginTop:'0.5rem',color:this.state.sectionQuestions2_1_Answered==false?"red":"green"}}>
                        {
                        sectionQuestions1_1.slice(0, 1).map((List, counting)=>(
                        <div style={{fontSize:'13px'}}> 
                           {sectionQuestions1_1[0]['SuggestionValue']}
                        </div>
                        ))}

                        
                        <div className="row"  style={{marginTop:'1.5rem'}}>
                           <div className="col-sm-6 col-md-12">

                              
                              
                              You can also mark your most important objective as primary by clicking <img alt = "Primary" src="assets/primary.svg"  width="20px" height="20px" style={{marginRight:'0.4rem'}}/>
                              <br/><br/>
                              {this.state.sectionQuestions2_1_Answered==false?(
                           <p style={{color:'red'}}><i class="fa fa-exclamation-circle" aria-hidden="true"></i> Please select one option</p>
                           ):
                           (<p style={{color:'green'}}><i class="fa fa-check-circle" aria-hidden="true"></i> Please click <b>next</b> to proceed</p>)
                           }
                           </div>
                           
                           <div className="col-sm-6 col-md-6" hidden>
                              <img alt = "Secondary" src="assets/secondary.svg"  width="20px" height="20px" style={{marginRight:'0.4rem'}}/>
                              Secondary
                           </div>
                        </div>
                     </div>
                  </div>
                  <button type="submit" disabled={this.state.sectionQuestions2_1_Answered==false?"disabled":""} className="btn next-btn" id="submit-button">Next</button>
                  <div className="back-button" id="back-btn">
                     <img alt = "back" src="assets/back_arrow.svg" width="25px" height="45px"/>
                     Back
                  </div>
                  <div id="progress-bar-container">
                     <div className="progress">
                        <div className="progress-bar step-done">1</div>
                        <div className="progress-bar">2</div>
                        <div className="progress-bar">3</div>
                        <div className="progress-bar">4</div>
                        <div className="progress-bar">5</div>
                        <div className="progress-bar">6</div>
                        <div className="progress-bar">7</div>
                        <div className="progress-bar">8</div>
                        <div className="progress-bar">9</div>
                        <div className="progress-bar">10</div>
                     </div>
                  </div>
               </div>
               </div>
               </div>
                  {/* ///////////////  END OF STEP 1//////////// */}

               {/* ////////////////// STEP 2  ///////////////////*/}
               <div className="main-container card">
                  <div className="row">
                  <div className="innerHeadingSection">
                     <h4>{this.state.sectionHeading1}</h4>
                     <h6></h6>
                  </div>
                     <div className="col-md-7">
                        {sectionQuestions1_2  && sectionQuestions1_2.length>0? sectionQuestions1_2.map((List, index)=>(
                        <div id="questions-container">
                           <div className="card questions-card" style={{marginBottom:'0.25rem'}}>
                              <div className="row">
                                 <div className="col-sm-12 col-md-12">
                                    <div className="question-div" >{List.QuestionText}</div>
      
                                    <Tooltip title={"Guidlines for Stages of Life Cycle: "+sectionQuestions1_2[0]['SuggestionValue']} arrow>
 
 <img alt = "Info" src="assets/message.svg" width="17px" height="17px" sx={{ m: 1 }} />
</Tooltip>
      
                                 </div>
                              </div>
                           </div>
                           
                           <div className="card-body" style={{paddingLeft:'0.5rem',  paddingBottom:'0'}}>
                           <div className="row">
                              {  
                              List.optionsDetails && List.optionsDetails.length>0 ? List.optionsDetails.map((optionsList, optionIndex)=>(
                              <div className="col-md-12 col-lg-6">
                                 <div className="form-check">
                                    <input type="radio"
                                       id={String(List.QuestionID+String(optionIndex))} 
                                       className="form-check-input" name={"optradio3".concat(index)} 
                                       value=  {String(optionsList.OptionScoreValue)}
                                       onChange={e => this.handleValueChanges('2',sectionQuestions1_2,List.optionsDetails,List.optionsDetails.length, optionIndex, e, index, List.QuestionTypeCode)}/>
                                    <label className="form-check-label" htmlFor={String(List.QuestionID+String(optionIndex))} >   
                                    {optionsList.OptionText}
                                    </label>
                                 </div>
                              </div>
                              )): 
                              <p> No options found.</p>
                              }
                           </div>
                        </div>
                     </div>
                     ) ) : 
                     <p> No question found.</p>
                     }  
                     <div className="lifeCycleState">
                     <p>Select Your Life Cycle State: </p>
                     <br/>
                     <div className="row" style={{marginLeft:'40px'}}>
                        <Box  >
                           <Slider
                              aria-label="Custom LifeCycleState"
                              defaultValue={0}
                              value={SelectedLifeCycleState}
                              min={25}
                              max={85}
                              valueLabelDisplay="on"
                              marks={LifeCycleState}
                              onChange={e =>
                           this.onChangeSelectedLifeCycleState(sectionQuestions1_2, e)}
                           sx={{
                           width: 600,
                           color: '#67707D',
                           }}
                           />
                        </Box>
                        <br/>
                        
                     </div>
                     <hr/>
                     <p style={{fontSize:'11px'}}>Life cycle investing is a relatively new approach that takes into consideration the individual's age and work life stage and tweaks the risk of the investment portfolio accordingly. The main premise of Lifecycle investing is to safeguard an individual's wealth as he or she approaches retirement. To do so the investors risk is front loaded in the earlier parts of their investment journey and is then gradually reduced as they age. </p>
                     </div>  
                  </div>
                  <div className="col-md-5">
                     
                     <div className="card right-side-card life-cycle-card">
                        <div className="right-card-title"></div>
                        {  /*               
                        sectionQuestions1_2.slice(0, 1).map((List, counting)=>(
                        <div className="right-card-text"  style={{marginTop:'0.5rem', lineHeight: '1.25'}}>
                        {sectionQuestions1_2[0]['SuggestionValue']}
                     </div>
                     ))
                        */}
                     {   sectionQuestions1_2.slice(0, 1).map((List, counting)=>(
                     <div className="chart-wrapper">
                       

<TransformWrapper
        initialScale={1}
      //   initialPositionX={200}
      //   initialPositionY={100}
      >
        {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
          <React.Fragment>
            <div className="tools">
               <p>Preview Image:&nbsp;
              <a onClick={() => this.openModalLifeCycleState()} ><i className="fa fa fa-search-plus" aria-hidden="true"></i></a>
              </p>
            </div>
            <TransformComponent>
            <a onClick={() => this.openModalLifeCycleState()}  >
            <img alt = "Guide Chart" src={List.illustration} width="100%"/>
            </a>
             
            </TransformComponent>
            <br/>
            <div className="tools">
               <p>Zoom Image:&nbsp;
              <a onClick={() => zoomIn()}><i className="fa  fa-plus-circle" aria-hidden="true"></i></a>&nbsp;
              <a onClick={() => zoomOut()}><i className="fa fa-minus-circle" aria-hidden="true"></i></a>&nbsp;
              <a onClick={() => resetTransform()}><i className="fa fa-refresh" aria-hidden="true"></i></a>
              </p>
            </div>
          </React.Fragment>
        )}
      </TransformWrapper>


      <Modal id="TanC-modal" size="lg" dialogClassName="modal-90w" show={this.state.showModalLifeCycleState} backdrop="static" onHide={this.closeModalLifeCycleState.bind(this)}>
               <Modal.Header>
                  <Modal.Title style={{width:'95%'}}>
                     <div className="modal-heading">Life Cycle States</div>
                  </Modal.Title>
                  <a style={{width:'5%'}} onClick={this.closeModalLifeCycleState.bind(this)}><i className="fa fa-times"></i></a> 
               </Modal.Header>
               <Modal.Body >
                  
                     <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                           <div className="modal-body">
                           <img alt = "Guide Chart" src={List.illustration} width="100%"/>
                              </div>
                          
                           
                              
                        </div>
                     </div>
                  
               </Modal.Body>
            </Modal>




      


                     </div>
                     ))}
                  </div>
                  <button type="submit" className="btn next-btn" id="submit-button">Next</button>
                  <div className="back-button" id="back-btn">
                     <img alt = "" src="assets/back_arrow.svg" width="25px" height="45px"/>
                     Back
                  </div>
                  <div id="progress-bar-container">
                     <div className="progress">
                        <div className="progress-bar step-done">1</div>
                        <div className="progress-bar step-done">2</div>
                        <div className="progress-bar">3</div>
                        <div className="progress-bar">4</div>
                        <div className="progress-bar">5</div>
                        <div className="progress-bar">6</div>
                        <div className="progress-bar">7</div>
                        <div className="progress-bar">8</div>
                        <div className="progress-bar">9</div>
                        <div className="progress-bar">10</div>
                     </div>
                  </div>
               </div>
               </div>
               </div>
               {/* ///////////////  END OF STEP 2//////////// */}

               {/* ////////////////// STEP 3  ///////////////////*/}
               <div className="main-container card">
                  <div className="row">
                  <div className="innerHeadingSection">
                     <h4>{this.state.sectionHeading1}</h4>
                     <h6></h6>
                  </div>
                     <div className="col-md-7">
                        <div id="questions-container">
                           <div>
                              { sectionQuestions1_3 && sectionQuestions1_3.length>0? sectionQuestions1_3.map((List, index)=>(
                              <div>
                                 <div className="card questions-card" style={{marginBottom:'0.25rem'}}>
                                    <div className="row">
                                       <div className="col-sm-12 col-md-12">
                                          <div className="question-div" >{List.QuestionText}</div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="card-body"  style={{paddingLeft:'0.5rem',  paddingBottom:'0'}}>
                                 <div className="row">
                                    {List.optionsDetails  &&  List.optionsDetails.length > 0 ? List.optionsDetails.map((optionsList, optionIndex) => (
                                    <div className="col-md-12 col-lg-6">
                                       <div className="form-check">
                                          <input type="radio" id={String(List.QuestionID+String(optionIndex))} className="form-check-input" name={"optradio3".concat(index)}  value=  {String(optionsList.OptionScoreValue)}   onChange={e => this.handleValueChanges('',sectionQuestions1_3,List.optionsDetails,List.optionsDetails.length, optionIndex, e, index, List.QuestionTypeCode)}/>
                                          <label className="form-check-label" htmlFor={String(List.QuestionID+String(optionIndex))}>   
                                          {optionsList.OptionText}
                                          </label>
                                       </div>
                                    </div>
                                    )):
                                    <p> No options found.</p>
                                    }
                                 </div>
                              </div>
                           </div>
                           )):
                           <p> No question found.</p>
                           }
                        </div>
                     </div>
                  </div>
                  <div className="col-md-5">
                     <div className="card right-side-card" style={{visibility:'hidden'}}>
                     <img alt = "" src="assets/message.svg" width="25px" height="25px" />
                     <div className="right-card-text"  style={{marginTop:'0.5rem'}}>
                        {
                        sectionQuestions1_3.slice(0, 1).map((List, counting)=>(
                        <div  style={{fontSize:'14px'}}> 
                           {List.SuggestionValue}
                        </div>
                        ))}
                     </div>
                  </div>
                  <button type="submit" className="btn next-btn" id="submit-button">Next</button>
                  <div className="back-button" id="back-btn">
                     <img alt = "" src="assets/back_arrow.svg" width="25px" height="45px"/>
                     Back
                  </div>
                  <div id="progress-bar-container">
                     <div className="progress">
                        <div className="progress-bar step-done">1</div>
                        <div className="progress-bar step-done">2</div>
                        <div className="progress-bar step-done">3</div>
                        <div className="progress-bar">4</div>
                        <div className="progress-bar">5</div>
                        <div className="progress-bar">6</div>
                        <div className="progress-bar">7</div>
                        <div className="progress-bar">8</div>
                        <div className="progress-bar">9</div>
                        <div className="progress-bar">10</div>
                     </div>
                  </div>
               </div>
               </div>
               </div>
            {/* ///////////////  END OF STEP 3//////////// */}
         
               {/* ////////////////// STEP 4  ///////////////////*/}
               <div className="main-container card">
                  <div className="row">
                  <div className="innerHeadingSection">
                     <h4>{this.state.sectionHeading1}</h4>
                     <h6></h6>
                  </div>
                     <div className="col-md-7">
                        {sectionQuestions1_4  && sectionQuestions1_4.length>0? sectionQuestions1_4.map((List, index)=>(
                        <div id="questions-container">
                           <div className="card questions-card">
                              <div className="row">
                                 <div className="col-sm-12 col-md-12">
                                    <div className="question-div" >{List.QuestionText}</div>
                                 </div>
                              </div>
                           </div>
                           <div className="card-body" style={{ paddingBottom:'0'}}>
                           <div className="row">
                           {List.optionsDetails  &&  List.optionsDetails.length > 0 ? List.optionsDetails.map((optionsList, optionIndex) => (

                              
                           <>
                              {List.QuestionTypeCode=='20' ? (
                                 <div className="ps-options-wrapper">
                              <input type="checkbox" id={String(List.QuestionID+String(optionIndex))} name="ps_checkbox" value={String(optionsList.OptionScoreValue)} onChange={e => this.handleValueChangesMulti('4', sectionQuestions1_4,List.optionsDetails,List.optionsDetails.length, optionIndex, e, index, List.QuestionTypeCode, "primary".concat(String(optionIndex)))} className="ps-checkbox"/>
                              <label htmlFor={String(List.QuestionID+String(optionIndex))}>
                                 <div className="option-card option-card-lg">
                                    <i className="fa fa-check"  style={{marginRight:'0.5rem',   display: 'none'}}></i>
                                    {optionsList.OptionText}
                                    <input type="radio" id={"primary".concat(String(optionIndex))}
                                       disabled

                                       onChange={e => this.handlePrimaryValueChanges( "sectionQuestions1_4",  e,  "pr4".concat(String(List.SectionID).concat(String(index)).concat(String(optionIndex))))}
                                       name={"ps_radio".concat(String(List.SectionID))}  value="primary" className="ps-radio" /> 
                                    <label style={{visibility:optionsList.OptionText==="No Preference"?"hidden":""}} htmlFor={"primary".concat(String(optionIndex))}>
                                    <img alt = "" src="assets/primary.svg"  className="ps-tag" id="primary-icon" width="20px" height="20px" />
                              </label>
                              <div hidden>
                              <input type="radio" id={"secondary".concat(String(optionIndex))} name={'ps_radio'.concat(String(optionIndex))} value="secondary" className="ps-radio"/> 
                              <label htmlFor={"secondary".concat(String(optionIndex))}>
                              <img alt = "" src="assets/secondary.svg" className="ps-tag"  id="secondary-icon" width="18px" height="18px"/>
                              </label>
                              </div>
                              </div>
                              </label></div>
                              ):  
                              
                              <div className="col-md-12 col-lg-6">
                              <div className="form-check">
                                 <input type="radio"  id = {String(List.QuestionID+String(optionIndex))} className="form-check-input" name={"optradio5".concat(index)}   value=  {String(optionsList.OptionScoreValue)}  onChange={e => this.handleValueChanges('',sectionQuestions1_4,List.optionsDetails,List.optionsDetails.length, optionIndex, e, index, List.QuestionTypeCode)}/>
                                 <label className="form-check-label" htmlFor={String(List.QuestionID+String(optionIndex))}>   
                                 {optionsList.OptionText}
                                 </label>
                              </div>
                           </div>}
                           </>
                          
                          

                           )): 
                           <p> No options found</p>
                           }    
                           </div>   
                        </div>
                     </div>
                     )): 
                     <p> No question found.</p>
                     }
                  </div>
                  <div className="col-md-5">
                     <div className="card right-side-card">
                     
                     <div className="right-card-text">
                        { 
                        sectionQuestions1_4.slice(0, 1).map((List, counting)=>(
                        <div  style={{fontSize:'14px'}}> 
                           {List.SuggestionValue}
                        </div>
                        ))}
                        <div className="row"  style={{marginTop:'0.5rem',color:this.state.sectionQuestions1_4_Answered==false?"red":"green"}}>
                           <div className=" col-sm-6 col-md-12">
                           You can mark any specific geographic region as your primary preference by clicking <img alt = "" src="assets/primary.svg"  width="20px" height="20px" style={{marginRight:'0.4rem'}}/>
                           <br/><br/>
                           {this.state.sectionQuestions1_4_Answered==false?(
                           <p style={{color:'red'}}><i class="fa fa-exclamation-circle" aria-hidden="true"></i> Please select one option</p>
                           ):
                           (<p style={{color:'green'}}><i class="fa fa-check-circle" aria-hidden="true"></i> Please click <b>next</b> to proceed</p>)
                           }
                           </div>
                           
                           <div className=" col-sm-6 col-md-6" hidden>
                              <img alt = "Secondary" src="assets/secondary.svg"  width="20px" height="20px" style={{marginRight:'0.4rem'}}/>
                              Secondary
                           </div>
                        </div>
                     </div>
                  </div>
                  <button type="submit" className="btn next-btn" disabled={this.state.sectionQuestions1_4_Answered==false?"disabled":""} id="submit-button">Next</button>
                  <div className="back-button" id="back-btn">
                     <img alt = "" src="assets/back_arrow.svg" width="25px" height="45px"/>
                     Back
                  </div>
                  <div id="progress-bar-container">
                     <div className="progress">
                        <div className="progress-bar step-done">1</div>
                        <div className="progress-bar step-done">2</div>
                        <div className="progress-bar step-done">3</div>
                        <div className="progress-bar step-done">4</div>
                        <div className="progress-bar">5</div>
                        <div className="progress-bar">6</div>
                        <div className="progress-bar">7</div>
                        <div className="progress-bar">8</div>
                        <div className="progress-bar">9</div>
                        <div className="progress-bar">10</div>
                     </div>
                  </div>
               </div>
               </div>
               </div>
               {/* ///////////////  END OF STEP 4//////////// */}


               {/* ////////////////// STEP 5 ///////////////////*/}
               <div className="main-container card">
                  <div className="row">
                  <div className="innerHeadingSection">
                     <h4>{this.state.sectionHeading2}</h4>
                     <h6></h6>
                  </div>
                     <div className="col-md-7">
                        <div id="questions-container">
                           <div>
                              { sectionQuestions1_5 && sectionQuestions1_5.length>0? sectionQuestions1_5.map((List, index)=>(
                              <div>
                                 <div className="card questions-card" style={{marginBottom:'0.25rem'}}>
                                    <div className="row">
                                       <div className="col-sm-12 col-md-12">
                                          <div className="question-div" >{List.QuestionText}</div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="card-body"  style={{paddingLeft:'0.5rem',  paddingBottom:'0'}}>
                                 <div className="row">
                                    {List.optionsDetails  &&  List.optionsDetails.length > 0 ? List.optionsDetails.map((optionsList, optionIndex) => (
                                    <div className="col-md-12 col-lg-6">
                                       <div className="form-check">
                                          <input type="radio"  id = {String(List.QuestionID+String(optionIndex))} className="form-check-input" name={"optradio5".concat(index)}   value=  {String(optionsList.OptionScoreValue)}  onChange={e => this.handleValueChanges('7',sectionQuestions1_5,List.optionsDetails,List.optionsDetails.length, optionIndex, e, index, List.QuestionTypeCode)}/>
                                          <label className="form-check-label" htmlFor={String(List.QuestionID+String(optionIndex))}>   
                                          {optionsList.OptionText}
                                          </label>
                                       </div>
                                    </div>
                                    )):
                                    <p> No options found.</p>
                                    }
                                 </div>
                              </div>
                           </div>
                           )):
                           <p> No question found.</p>
                           }
                        </div>
                     </div>
                  </div>
                  <div className="col-md-5">
                     <div className="card right-side-card">
                     
                     <div className="right-card-text"  style={{marginTop:'0.5rem'}}>
                        {  sectionQuestions1_5.slice(0, 1).map((List, counting)=>(
                        <div  style={{fontSize:'14px'}}> 
                           {List.SuggestionValue}
                           <br/><br/>
                           {this.state.sectionQuestions1_5_Answered==false?(
                           <p style={{color:'red'}}><i class="fa fa-exclamation-circle" aria-hidden="true"></i> Please select one option</p>
                           ):
                           (<p style={{color:'green'}}><i class="fa fa-check-circle" aria-hidden="true"></i> Please click <b>next</b> to proceed</p>)
                           }
                        </div>
                        ))}
                     </div>
                  </div>
                  <button type="submit" className="btn next-btn" disabled={this.state.sectionQuestions1_5_Answered==false?"disabled":""} id="submit-button">Next</button>
                  <div className="back-button" id="back-btn">
                     <img alt = "" src="assets/back_arrow.svg" width="25px" height="45px"/>
                     Back
                  </div>
                  <div id="progress-bar-container">
                     <div className="progress">
                        <div className="progress-bar step-done">1</div>
                        <div className="progress-bar step-done">2</div>
                        <div className="progress-bar step-done">3</div>
                        <div className="progress-bar step-done">4</div>
                        <div className="progress-bar step-done">5</div>
                        <div className="progress-bar">6</div>
                        <div className="progress-bar">7</div>
                        <div className="progress-bar">8</div>
                        <div className="progress-bar">9</div>
                        <div className="progress-bar">10</div>
                     </div>
                  </div>
               </div>
               </div>
               </div>
            {/* ///////////////  END OF STEP 5//////////// */}

               {/* ////////////////// STEP 6 ///////////////////*/}
               <div className="main-container card">
                  <div className="row">
                  <div className="innerHeadingSection">
                     <h4>{this.state.sectionHeading2}</h4>
                     <h6></h6>
                  </div>
                     <div className="col-md-7">
                        <div id="questions-container">
                           <div>
                              { sectionQuestions1_6 && sectionQuestions1_6.length>0? sectionQuestions1_6.map((List, index)=>(
                              <div>
                                 <div className="card questions-card" style={{marginBottom:'0.25rem'}}>
                                    <div className="row">
                                       <div className="col-sm-12 col-md-12">
                                          <div className="question-div" >{List.QuestionText}</div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="card-body"  style={{paddingLeft:'0.5rem',  paddingBottom:'0'}}>
                                 <div className="row">
                                    {List.optionsDetails  &&  List.optionsDetails.length > 0 ? List.optionsDetails.map((optionsList, optionIndex) => (
                                    <div className="ps-options-wrapper">
                                       <div className="col-md-12 col-lg-12">
                                          <div className="form-check">
                                             <input type="radio" id = {String(List.QuestionID+String(optionIndex))} className="form-check-input" name={"optradio6".concat(index)}   value=  {String(optionsList.OptionScoreValue)}  onChange={e => this.handleValueChanges('',sectionQuestions1_6,List.optionsDetails,List.optionsDetails.length, optionIndex, e, index, List.QuestionTypeCode)}/>
                                             <label className="form-check-label" htmlFor={String(List.QuestionID+String(optionIndex))}>   
                                             {optionsList.OptionText}
                                             </label>
                                          </div>
                                       </div>
                                    </div>
                                    )):
                                    <p> No options found.</p>
                                    }
                                 </div>
                              </div>
                           </div>
                           )):
                           <p> No question found.</p>
                           }
                        </div>
                     </div>
                  </div>
                  <div className="col-md-5">
                     <div className="card right-side-card" style={{visibility:'hidden'}}>
                     <img alt = "Info" src="assets/message.svg" width="25px" height="25px" />
                     <div className="right-card-text"  style={{marginTop:'0.5rem'}}>
                        {  sectionQuestions1_6.slice(0, 1).map((List, counting)=>(
                        <div  style={{fontSize:'14px'}}> 
                           {List.SuggestionValue}
                        </div>
                        ))}
                     </div>
                  </div>
                  <button type="submit" className="btn next-btn" id="submit-button">Next</button>
                  <div className="back-button" id="back-btn">
                     <img alt = "" src="assets/back_arrow.svg" width="25px" height="45px"/>
                     Back
                  </div>
                  <div id="progress-bar-container">
                     <div className="progress">
                        <div className="progress-bar step-done">1</div>
                        <div className="progress-bar step-done">2</div>
                        <div className="progress-bar step-done">3</div>
                        <div className="progress-bar step-done">4</div>
                        <div className="progress-bar step-done">5</div>
                        <div className="progress-bar step-done">6</div>
                        <div className="progress-bar">7</div>
                        <div className="progress-bar">8</div>
                        <div className="progress-bar">9</div>
                        <div className="progress-bar">10</div>
                     </div>
                  </div>
               </div>
               </div>
               </div>
               {/* ///////////////  END OF STEP 6//////////// */}


               {/* ////////////////// STEP 7  ///////////////////*/}
               <div className="main-container card">
                  <div className="row">
                  <div className="innerHeadingSection">
                     <h4>{this.state.sectionHeading2}</h4>
                     <h6></h6>
                  </div>
                     <div className="col-md-7">
                        <div id="questions-container">
                           <div>
                              { sectionQuestions1_7 && sectionQuestions1_7.length>0? sectionQuestions1_7.map((List, index)=>(
                              <div>
                                 <div className="card questions-card" style={{marginBottom:'0.25rem'}}>
                                    <div className="row">
                                       <div className="col-sm-12 col-md-12">
                                          <div className="question-div" >{List.QuestionText}</div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="card-body"  style={{paddingLeft:'0.5rem',  paddingBottom:'0'}}>
                                 <div className="row">
                                    {List.optionsDetails  &&  List.optionsDetails.length > 0 ? List.optionsDetails.map((optionsList, optionIndex) => (
                                    <div className="ps-options-wrapper">
                                       <div className="col-md-12 col-lg-12">
                                          <div className="form-check">
                                             <input type="radio" id = {String(List.QuestionID+String(optionIndex))} className="form-check-input" name={"optradio7".concat(index)}   value=  {String(optionsList.OptionScoreValue)}  onChange={e => this.handleValueChanges('',sectionQuestions1_7,List.optionsDetails,List.optionsDetails.length, optionIndex, e, index, List.QuestionTypeCode)}/>
                                             <label className="form-check-label" htmlFor={String(List.QuestionID+String(optionIndex))}>   
                                             {optionsList.OptionText}
                                             </label>
                                          </div>
                                       </div>
                                    </div>
                                    )):
                                    <p> No options found.</p>
                                    }
                                 </div>
                              </div>
                           </div>
                           )):
                           <p> No question found.</p>
                           }
                        </div>
                     </div>
                  </div>
                  <div className="col-md-5">
                     <div className="card right-side-card" style={{visibility:'hidden'}}>
                     <img alt = "Info" src="assets/message.svg" width="25px" height="25px" />
                     <div className="right-card-text"  style={{marginTop:'0.5rem'}}>
                        { sectionQuestions1_7.slice(0, 1).map((List, counting)=>(
                        <div  style={{fontSize:'14px'}}> 
                           {List.SuggestionValue}
                        </div>
                        ))}
                     </div>
                  </div>
                  <button type="submit" className="btn next-btn" id="submit-button">Next</button>
                  <div className="back-button" id="back-btn">
                     <img alt = "" src="assets/back_arrow.svg" width="25px" height="45px"/>
                     Back
                  </div>
                  <div id="progress-bar-container">
                     <div className="progress">
                        <div className="progress-bar step-done">1</div>
                        <div className="progress-bar step-done">2</div>
                        <div className="progress-bar step-done">3</div>
                        <div className="progress-bar step-done">4</div>
                        <div className="progress-bar step-done">5</div>
                        <div className="progress-bar step-done">6</div>
                        <div className="progress-bar step-done">7</div>
                        <div className="progress-bar">8</div>
                        <div className="progress-bar">9</div>
                        <div className="progress-bar">10</div>
                     </div>
                  </div>
               </div>
               </div>
               </div>
            {/* ///////////////  END OF STEP 7//////////// */}


            {/* ////////////////// STEP 8  ///////////////////*/}
            <div className="main-container card">
                  <div className="row">
                  <div className="innerHeadingSection">
                     <h4>{this.state.sectionHeading2}</h4>
                     <h6></h6>
                  </div>
                     <div className="col-md-7">
                        <div id="questions-container">
                           <div>
                              { sectionQuestions1_8 && sectionQuestions1_8.length>0? sectionQuestions1_8.map((List, index)=>(
                              <div>
                                 <div className="card questions-card" style={{marginBottom:'0.25rem'}}>
                                    <div className="row">
                                       <div className="col-sm-12 col-md-12">
                                          <div className="question-div" >{List.QuestionText}</div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="card-body"  style={{paddingLeft:'0.5rem',  paddingBottom:'0'}}>
                                 <div className="row">
                                    {List.optionsDetails  &&  List.optionsDetails.length > 0 ? List.optionsDetails.map((optionsList, optionIndex) => (
                                    <div className="ps-options-wrapper">
                                       <div className="col-md-12 col-lg-12">
                                          <div className="form-check">
                                             <input type="radio" id = {String(List.QuestionID+String(optionIndex))} className="form-check-input" name={"optradio8".concat(index)}   value=  {String(optionsList.OptionScoreValue)}  onChange={e => this.handleValueChanges('',sectionQuestions1_8,List.optionsDetails,List.optionsDetails.length, optionIndex, e, index, List.QuestionTypeCode)}/>
                                             <label className="form-check-label" htmlFor={String(List.QuestionID+String(optionIndex))}>   
                                             {optionsList.OptionText}
                                             </label>
                                          </div>
                                       </div>
                                    </div>
                                    )):
                                    <p> No options found.</p>
                                    }
                                 </div>
                              </div>
                           </div>
                           )):
                           <p> No question found.</p>
                           }
                        </div>
                     </div>
                  </div>
                  <div className="col-md-5">
                     <div className="card right-side-card" style={{visibility:'hidden'}}>
                     <img alt = "Info" src="assets/message.svg" width="25px" height="25px" />
                     <div className="right-card-text"  style={{marginTop:'0.5rem'}}>
                        { sectionQuestions1_8.slice(0, 1).map((List, counting)=>(
                        <div  style={{fontSize:'14px'}}> 
                           {List.SuggestionValue}
                        </div>
                        ))}
                     </div>
                  </div>
                  <button type="submit" className="btn next-btn" id="submit-button">Next</button>
                  <div className="back-button" id="back-btn">
                     <img alt = "" src="assets/back_arrow.svg" width="25px" height="45px"/>
                     Back
                  </div>
                  <div id="progress-bar-container">
                     <div className="progress">
                        <div className="progress-bar step-done">1</div>
                        <div className="progress-bar step-done">2</div>
                        <div className="progress-bar step-done">3</div>
                        <div className="progress-bar step-done">4</div>
                        <div className="progress-bar step-done">5</div>
                        <div className="progress-bar step-done">6</div>
                        <div className="progress-bar step-done">7</div>
                        <div className="progress-bar step-done">8</div>
                        <div className="progress-bar">9</div>
                        <div className="progress-bar">10</div>
                     </div>
                  </div>
               </div>
               </div>
               </div>
            {/* ///////////////  END OF STEP 8//////////// */}

               {/* ///////////////  END OF STEP 9//////////// */}
               <div className="main-container card">
                  <div className="row">
                  <div className="innerHeadingSection">
                     <h4>{this.state.sectionHeading2}</h4>
                     <h6></h6>
                  </div>
                     <div className="col-md-7">
                        <div id="questions-container">
                           <div>
                              { sectionQuestions1_9 && sectionQuestions1_9.length>0? sectionQuestions1_9.map((List, index)=>(
                              <div>
                                 <div className="card questions-card" style={{marginBottom:'0.25rem'}}>
                                    <div className="row">
                                       <div className="col-sm-12 col-md-12">
                                          <div className="question-div" >{List.QuestionText}</div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="card-body"  style={{paddingLeft:'0.5rem',  paddingBottom:'0'}}>
                                 <div className="row">
                                    {List.optionsDetails  &&  List.optionsDetails.length > 0 ? List.optionsDetails.map((optionsList, optionIndex) => (
                                    <div className="col-md-12 col-lg-12">
                                       <div className="ps-options-wrapper">
                                          <div className="form-check">
                                             <input type="radio" id = {String(List.QuestionID+String(optionIndex))} className="form-check-input" name={"optradio9".concat(index)}   value=  {String(optionsList.OptionScoreValue)}  onChange={e => this.handleValueChanges('',sectionQuestions1_9,List.optionsDetails,List.optionsDetails.length, optionIndex, e, index, List.QuestionTypeCode)}/>
                                             <label className="form-check-label" htmlFor={String(List.QuestionID+String(optionIndex))} >   
                                             {optionsList.OptionText}
                                             </label>
                                          </div>
                                       </div>
                                    </div>
                                    )):
                                    <p> No options found.</p>
                                    }
                                 </div>
                              </div>
                           </div>
                           )):
                           <p> No question found.</p>
                           }
                        </div>
                     </div>
                  </div>
                  <div className="col-md-5">
                     <div className="card right-side-card">
                     
                     <div className="right-card-text"  style={{marginTop:'0.5rem'}}>
                        {
                        sectionQuestions1_9.slice(0, 1).map((List, counting)=>(
                        <div  className="chart-wrapper"> 
                         
                           
                           <TransformWrapper
        initialScale={1}
     
      >
        {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
          <React.Fragment>
             <div className="tools">
              <p>Preview Image:&nbsp;
              <a onClick={() => this.openModalHighestPotential()} ><i className="fa fa fa-search-plus" aria-hidden="true"></i></a>
              </p>
            </div>
            <TransformComponent>
            <a onClick={() => this.openModalHighestPotential()} >
            <img alt = "Guide Chart" src={List.illustration} width="100%"/>
            </a>
             
            </TransformComponent>
            <br/>
            <p>Zoom Image:&nbsp;
              <a onClick={() => zoomIn()}><i className="fa fa-plus-circle" aria-hidden="true"></i></a>&nbsp;
              <a onClick={() => zoomOut()}><i className="fa fa-minus-circle" aria-hidden="true"></i></a>&nbsp;
              <a onClick={() => resetTransform()}><i className="fa fa-refresh" aria-hidden="true"></i></a>
              </p>
          </React.Fragment>
        )}
      </TransformWrapper>


      <Modal id="TanC-modal" size="lg" dialogClassName="modal-90w" show={this.state.showModalHighestPotential} backdrop="static" onHide={this.closeModalHighestPotential.bind(this)}>
               <Modal.Header>
                  <Modal.Title style={{width:'95%'}}>
                     <div className="modal-heading">Highest potential one-year loss and gain</div>
                  </Modal.Title>
                  <a style={{width:'5%'}} onClick={this.closeModalHighestPotential.bind(this)}><i className="fa fa-times"></i></a> 
               </Modal.Header>
               <Modal.Body >
                  
                     <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                           <div className="modal-body">
                           <img alt = "Guide Chart" src={List.illustration} width="100%"/>
                              </div>
                          
                           
                              
                        </div>
                     </div>
                  
               </Modal.Body>
            </Modal>

                        </div>
                        ))}
                     </div>
                  </div>
                  <button type="submit" className="btn next-btn" id="submit-button">Next</button>
                  <div className="back-button" id="back-btn">
                     <img alt = "" src="assets/back_arrow.svg" width="25px" height="45px"/>
                     Back
                  </div>
                  <div id="progress-bar-container">
                     <div className="progress">
                        <div className="progress-bar step-done">1</div>
                        <div className="progress-bar step-done">2</div>
                        <div className="progress-bar step-done">3</div>
                        <div className="progress-bar step-done">4</div>
                        <div className="progress-bar step-done">5</div>
                        <div className="progress-bar step-done">6</div>
                        <div className="progress-bar step-done">7</div>
                        <div className="progress-bar step-done">8</div>
                        <div className="progress-bar step-done">9</div>
                        <div className="progress-bar">10</div>
                     </div>
                  </div>
               </div>
               </div>
               </div> 
               {/* ///////////////  END OF STEP 9//////////// */}

               


                {/* ////////////////// STEP 10  ///////////////////*/}
                <div className="main-container card risk-range-wrapper">
                  <div className="row">
                  <div className="innerHeadingSection">
                     <h4>{this.state.sectionHeading2}</h4>
                     <h6></h6>
                  </div>
                     <div className="col-md-12">
                        <div className="section10Slider">
                     <div className="range-specifier-container">
                           <div className="line-container">
                              <span style={{marginRight:"1rem"}}>Lower Expected Return & Low Risk</span>
                              <span className="line arrow-left"></span>
                              <span className="line arrow-right"></span>
                              <span style={{marginRight:"1rem"}}>Higher Expected Return & High Risk</span>
                           </div>
                        </div>
                        <br></br>
                        
                         
                       <div className="preference-wrapper">
                           <div className="preference-title card-title">
                              Based on the principal’s feelings about risk and potential returns, what is your goal?
                           </div>
                           <br/>
                           <div className="preference-slider">
                              <div className="row" style={{marginLeft:'100px'}}>

                                 
                                 <Box  >
                                    <Slider
                                       aria-label="Custom Values"
                                       defaultValue={0}
                                       value={SelectedCapitalSafety}
                                       step={5}
                                       min={5}
                                       max={20}
                                       valueLabelDisplay="off"
                                       marks={sectionQuestions2_1_Sliders[0]}
                                       onChange={e =>
                                    this.onChangeSelectedCapitalSafety(sectionQuestions2_1, e, sectionQuestions2_1_Sliders[0])}
                                    sx={{
                                    width: 1000,
                                    color: '#67707D',
                                    }}
                                    />
                                 </Box>
                               
                              </div>
                           </div>
                        </div>
                        <div className="preference-wrapper">
                           <div className="preference-title card-title">
                              Which of the following statements best describes the principal’s overall approach to investing as a means of achieving your goals?
                           </div>
                           <div className="preference-slider">
                              <div className="row" style={{marginLeft:'100px'}}>
                                 <Box  >
                                    <Slider
                                       aria-label="Custom Values"
                                       defaultValue={0}
                                       value={SelectedRiskPreference}
                                       step={5}
                                       min={5}
                                       max={25}
                                       valueLabelDisplay="off"
                                       marks={sectionQuestions2_1_Sliders[1]}
                                       onChange={e =>
                                    this.onChangeSelectedRiskPreference(sectionQuestions2_1, e, sectionQuestions2_1_Sliders[1])}
                                    sx={{
                                    width: 1000,
                                    color: '#67707D',
                                    }}
                                    />
                                 </Box>
                              </div>
                           </div>
                        </div>
                        <div className="preference-wrapper">
                           <div className="preference-title card-title">
                              Which of the following investments would the principal choice to add to your investment
                              portfolio?
                           </div>
                           <div className="preference-slider">
                              <div className="row" style={{marginLeft:'100px'}}>
                                 <Box  >
                                    <Slider
                                       aria-label="Custom Values"
                                       defaultValue={0}
                                       value={SelectedProductPreference}
                                       step={5}
                                       min={5}
                                       max={20}
                                       valueLabelDisplay="off"
                                       marks={sectionQuestions2_1_Sliders[2]}
                                       onChange={e =>
                                    this.onChangeSelectedProductPreference(sectionQuestions2_1, e, sectionQuestions2_1_Sliders[2])}
                                    sx={{
                                    width: 1000,
                                    color: '#67707D',
                                    }}
                                    />
                                 </Box>
                              </div>
                           </div>
                        </div> 

                        </div>

                        <div className="section10Radio">
                        {sectionQuestions2_1  && sectionQuestions2_1.length>0? sectionQuestions2_1.map((List, index)=>(
                        <div id="questions-container">
                           <div className="card questions-card" style={{marginBottom:'0.25rem'}}>
                              <div className="row">
                                 <div className="col-sm-12 col-md-12">
                                    <div className="question-div" >{List.QuestionText}</div>
                                    
                                 </div>
                              </div>
                           </div>
                           <div className="card-body" style={{paddingLeft:'0.5rem',  paddingBottom:'0'}}>
                           <div className="row">
                              {  
                              List.optionsDetails && List.optionsDetails.length>0 ? List.optionsDetails.map((optionsList, optionIndex)=>(
                              <div className="col-md-12 col-lg-6">
                                 <div className="form-check">
                                    <input type="radio"
                                       id={String(List.QuestionID+String(optionIndex))} 
                                       className="form-check-input" name={"optradio3".concat(index)} 
                                       value=  {String(optionsList.OptionScoreValue)}
                                       onChange={e => this.handleValueChanges('',sectionQuestions2_1,List.optionsDetails,List.optionsDetails.length, optionIndex, e, index, List.QuestionTypeCode)}/>
                                    <label className="form-check-label" htmlFor={String(List.QuestionID+String(optionIndex))} >   
                                    {optionsList.OptionText}
                                    </label>
                                 </div>
                              </div>
                              )): 
                              <p> No options found.</p>
                              }
                           </div>
                        </div>
                     </div>
                     ) ) : 
                     <p> No question found.</p>
                     } 
                 
                 </div>
                 <div className="offset-md-7 col-md-5">
                 <button type="submit" className="btn next-btn slider-next-btn" 
                    
                    id= "buttonForm" onClick={e => this.submitData()} style={{marginTop:"0"}}
                    
                  
                    >Next</button>




                    

                 <div  className="slider-button-div">
                              <div className="">
                                 <div className="col-md-12">
                                    <div className="back-button slider-back-btn" id="back-btn">
                                       <img alt = "" src="assets/back_arrow.svg" width="25px" height="45px"/>
                                       Back
                                    </div>
                                 </div>
                                
                                    


                   

                                    <p style={{color:'red'}} className='p_message'>{this.state.dataFillingMessageError}</p>
                                 <p style={{color:'success'}} className='p_message'>{this.state.dataFillingMessageSuccess}</p>
                                

                                 
                              </div>
                           </div>
                           
                              <div style={{marginTop:"1rem"}}>
                                 <div className="progress">
                                    <div className="progress-bar step-done">1</div>
                                    <div className="progress-bar step-done">2</div>
                                    <div className="progress-bar step-done">3</div>
                                    <div className="progress-bar step-done">4</div>
                                    <div className="progress-bar step-done">5</div>
                                    <div className="progress-bar step-done">6</div>
                                    <div className="progress-bar step-done">7</div>
                                    <div className="progress-bar step-done">8</div>
                                    <div className="progress-bar step-done">9</div>
                                    <div className="progress-bar step-done">10</div>
                                 </div>
                              </div>
                           </div>
                           
                        
                        {/* </div> */}


               </div>
               </div>
               </div>
               {/* ///////////////  END OF STEP 10//////////// */}

{/* ////////////////////////////////////////////////////////////// */}

     

              {/* //////////////////////////////////////////////////// */}

              

               <div className="main-container card risk-range-wrapper risk-assessment-tabs">


               <div className="">
              <div className="row">
                <div className="col-xs-12" style={{width:'100%'}}>
                  <nav>
                    <div className="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                      <a className="nav-item nav-link active" onClick={e => this.tabClick()}  id="nav-home-tab"    data-toggle="tab" href="#nav-home"    role="tab" aria-controls="nav-home"    aria-selected="true">Recommended Model</a>
                      <a className="nav-item nav-link"        onClick={e => this.tabClick()}  id="nav-contact-tab" data-toggle="tab" href="#nav-contact" role="tab" aria-controls="nav-contact" aria-selected="false">Explore More Models</a>
                      <a className="nav-item nav-link"                                        id="nav-profile-tab" data-toggle="tab" href="#nav-profile" role="tab" aria-controls="nav-profile" aria-selected="false"> Definitions & Keywords</a>
                      
                    </div>
                  </nav>
                  <div className="tab-content" id="nav-tabContent">
                    <div className="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                       {
                          this.state.showProgressBar==true?(<div style={{textAlign:'center'}}><img alt = "loading..." style={{width:'50%'}} src="/img/progess-bar.gif"/></div>):(<div>
                        
            
            <div id="recommendation-tabtoPDF">
             <div className="row">
            
                <div className="col-md-5 col-lg-5 risk-assessment-div">
                
                    <div id="risk-assessment-heading">Preliminary Risk Assessment</div>
                    <div className="risk-assessment-level">
                    {CalculatedModelType}
                    </div>
                   
                    <div className="row risk-calculation-div">

                        <div className="col-md-12 justify-content-end"  style={{paddingRight:'0'}}>
                            <div onClick={this.closeModalAndGoBack.bind(this)} className="risk-calculation-btn modal-back-btn back-button">
      Recalculate Risk
   </div>
                          </div> 
                   </div>
                    
                </div>
               
               
                       <div className="col-md-7 col-lg-7 donut-chart-wrapper">
                <Chart
   width={'100%'}
   height={'400px'}
   chartType="PieChart"
   loader={
   <div>Loading Chart...</div>
   }
   data={PreliminaryRiskAssessmentChart}
   options={pieOptions}
   rootProps={{ 'data-testid': '3' }}
   />
                </div>  
               
               
             </div>

             <div className="card risk-assessment-table-wrapper ">
                <div className="table-responsive">
               
                <Table  className="table portfolio-table table-borderless">
                      <Thead>
                        <Tr>
                          <Th>Portfolio</Th>
                          <Th>Return</Th>
                          <Th>Yield</Th>
                          <Th>StdDev</Th>
                          <Th>Sharpe Ratio</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        <Tr>
                          <Td>{CalculatedModelType}</Td>
                          <Td>{parseFloat(CalculatedModelTypeValues[0]).toFixed(1)}%</Td>
                          <Td>{parseFloat(CalculatedModelTypeValues[1]).toFixed(1)}%</Td>
                          <Td>{parseFloat(CalculatedModelTypeValues[2]).toFixed(1)}%</Td>
                          <Td>{parseFloat(CalculatedModelTypeValues[3]).toFixed(1)}</Td>
                        </Tr>
                      </Tbody>
                    </Table>
                   
                 
                 </div>  
          </div>

             <div className="growth-chart">
          <Chart
  chartType="AreaChart"
  data={_100DollarChart}
  width="100%"
  height="400px" 
  legend= { {position: 'top', fontSize: 10}}
  options={{title: "100 Million US Dollars Growth*",  
            vAxis: {
                   title: 'Portfolio Value'},
            hAxis: {
            title: 'Future Years'}
            }}
/>
<p>*<i>hypothetical return for illustrative purposes</i></p>
          </div>

             <div className="table-responsive">
               



<Table className="table table-borderless asset-table">
                    <Thead>
                      <Tr>
                        <Th>Asset Class</Th>
                        <Th>{CalculatedModelType}</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      
                     
                      { PreliminaryRiskAssessmentChart.slice(1, PreliminaryRiskAssessmentChart.length).map((List, counting)=>(
                        PreliminaryRiskAssessmentChart[counting+1][1]!==0?
                        (
                         <Tr>
                         <Td>{PreliminaryRiskAssessmentChart[counting+1][0]}</Td>
                         <Td>{((PreliminaryRiskAssessmentChart[counting+1][1]).toString()).substr(0,4)}%</Td>
                       </Tr>
                         ) : ""
                        ))}
                    </Tbody>
                  </Table>





               </div> 



               <p><b>Disclaimer:</b> These model portfolios are illustrations and is provided for educational and/or informational purposes only. They are not intended as investment advice or recommendations.</p>
               <div><h5>For more details, please contact</h5>
               <p><i className="fa fa-envelope-o" aria-hidden="true"></i> <b>Email:</b> <a href="mailto:cs@watarpartners.com">cs@watarpartners.com</a> </p>
               </div>
             

          </div>
      
          

          <div className="export-buttons-div">

            {/*
            <a className="share-btn exp-pdf-btn"  onClick={e => this.printDocument('recommendation-tabtoPDF')}>
               Export To PDF
            </a>
                        */}


            <a className="share-btn exp-pdf-btn btn-success"  onClick={e => this.GeneratePDF(this.state.CalculatedModelType ,  this.state.CalculatedModelTypeValues ,  this.state.PreliminaryRiskAssessmentChart)}>
               {/* Generate PDF */}
               {this.state.pdfGenerationButtonText}
               
                
            </a>



            &nbsp;
            <div className="share-btn btn-primary"     onClick={e => this.emailUser(this.state.CalculatedModelType ,  this.state.CalculatedModelTypeValues ,  this.state.PreliminaryRiskAssessmentChart)}>

                Send Via Email
            </div>
            <p>{this.state.emailMessage }</p>
          </div>

          
          </div>)
         }
                         
          
                    </div>
                    
                    


                    {/* //////////// ///////////////////// Custom Models Tab/////////////////////////////// */}
                   

                    <div className="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
                   {this.state.showProgressBar==true?(<div style={{textAlign:'center'}}><img alt = "loading..." style={{width:'50%'}} src="/img/progess-bar.gif"/></div>):(<div>
                     <div id="__customized-tabtoPDF__">
        
           <div className="row customized-radio-wrapper">
             <div className="col-sm-12 col-md-3"></div>
             <div className="col-sm-12 col-md-3">Explore More Models:</div>
                
            
            { _ALL_Models.map((List, counting)=>(  
            <div className="col-sm-12 col-md-2 float-right">
               
               {/* CalculatedModelType */}
              <input type="radio" id={"otherModel"+counting}  className="form-check-input customized-radio-input"  name="custommodelradio" 
              value={ _ALL_Models[counting]}
              defaultChecked={_ALL_Models[counting]==CalculatedModelType? "checked":""}
              onChange={e => this.handleOtherModelTypeChanges(_ALL_Models[counting], e)}
              
              />
              &nbsp;
              <label htmlFor={"otherModel"+counting} className="form-check-label">{ _ALL_Models[counting]}</label>
                 </div>
                
                ))}
            
            
            
           </div>

           
           <div className="col-md-12 col-lg-12">
              <div className="row">
              <div className="col-md-7 col-lg-7">
          <div className="table-responsive">
            


<Table className="table table-borderless asset-table customized-table">
                <Thead>
                  <Tr>
                    <Th>Asset Class</Th>
                    <Th>{CalculatedModelType}</Th>
                    <Th></Th>
                    <Th>{/*Custom_Model*/}Customized {/*<img  alt = "Edit" src="assets/edit_icon.svg" className="edit-icon"/> */}</Th>
                  </Tr>
                </Thead>

                <Tbody>
              

{ Custom_ModelArray.map((List, counting)=>(
                 <Tr>
                 <Td>{PreliminaryRiskAssessmentChart[counting+1][0]}</Td>
                 <Td>{((PreliminaryRiskAssessmentChart[counting+1][1]).toString()).substr(0,4)}%</Td>
                 <Td></Td>
                 <Td id = {String("customizedTDValue"+String(counting))}> 
                 <input id = {String("customizedFieldTDValue"+String(counting))} type="number" min='0' max='100' className="edit-input" onChange={e => this.handleCustomClassChanges(counting,PreliminaryRiskAssessmentChart[counting+1][0],e)} name={PreliminaryRiskAssessmentChart[counting+1][0]} value={((Custom_ModelArray[counting].assetClassValue).toString()).substr(0,4)} />% {/*<img alt = "Edit" src="assets/edit_icon.svg" className="edit-icon"/> */}
                 </Td>
                
               </Tr>
                ))} 
                  <Tr style={{display:'none'}}>
                    <Td></Td>
                    <Td></Td>
                    <Td></Td>
                    <Td></Td>
                  </Tr>

                  
                </Tbody>
              </Table>
              

              <p style={{color:'red', textAlign:'right', margin:'5px'}}>{this.state.reloadbtn==false? "Total= "+this.state.sumOfWeights.toFixed(1)+" (sum of weights should be 100)":""}</p>

              {this.state.reloadbtn==true?(
                      <><a disabled={this.state.reloadbtn==false? "disabled":""}  onClick={e => this.reloadData(e)} className="reload-btn">
                      <img width="20px" alt = "Reload" src="assets/reload_icon.svg"/>
                      Reload
                  </a> customize values
                    </>
              ):''}



           </div>
           </div>


           <div className="col-md-5 col-lg-5">
              <div className="row">

              <div className="col-md-12 col-lg-12">
              <h4 style={{textAlign:'center',background:'#FF7F50'}}>{CalculatedModelType}</h4>
                               <Chart
   width={'100%'}
   height={'300px'}
   chartType="PieChart"
   loader={
   <div>Loading Chart</div>
   }
   data={PreliminaryRiskAssessmentChart}
   options={pieOptions}
   rootProps={{ 'data-testid': '3' }}
   />

   </div>

   <div className="col-md-12 col-lg-12">
      <h4 style={{textAlign:'center',background:'#FF7F50'}}>{/*Custom_Model*/} Customized </h4>
                
                               <Chart
                                 width={'100%'}
                                 height={'300px'}
                                 chartType="PieChart"
                                 loader={
                                 <div>Loading Chart</div>
                                 }
                                 data={CustomModelChart}
                                 options={pieOptions}
                                 rootProps={{ 'data-testid': '3' }}
                                 />
                   </div>

                  </div>
           </div>



           </div>
           </div>

           
           
           <div className="card risk-assessment-table-wrapper">
            <div className="table-responsive">
              

<Table className="table portfolio-table table-borderless">
                  <Thead>
                    <Tr>
                      <Th>Portfolio</Th>
                      <Th>Return</Th>
                      <Th>Yield</Th>
                      <Th>StdDev</Th>
                      <Th>Sharpe Ratio</Th>
                    </Tr>
                  </Thead>
                  {this.state.needreloadbtnclick == false ? (
                  <Tbody>
                    <Tr>
                          <Td>{CalculatedModelType}</Td>
                          <Td>{parseFloat(CalculatedModelTypeValues[0]).toFixed(1)}%</Td>
                          <Td>{parseFloat(CalculatedModelTypeValues[1]).toFixed(1)}%</Td>
                          <Td>{parseFloat(CalculatedModelTypeValues[2]).toFixed(1)}%</Td>
                          <Td>{parseFloat(CalculatedModelTypeValues[3]).toFixed(1)}</Td>
                    </Tr>
                    
                    { Custom_ModelArray.slice(0,1).map((List, counting)=>(
                 <Tr>
                <Td> {/*Custom_Model*/}Customized </Td>
                
                      
                      <Td id = {String("modelValues"+String(0))}> {parseFloat(this.state.Custom_ModelArray[0].returnValue).toFixed(1)}% </Td>
                      <Td id = {String("modelValues"+String(1))}> {parseFloat(this.state.Custom_ModelArray[0].yield).toFixed(1)}% </Td>
                      <Td id = {String("modelValues"+String(2))}> {parseFloat(this.state.Custom_ModelArray[0].standardDeviation).toFixed(1)}% </Td>
                      <Td id = {String("modelValues"+String(3))}> {parseFloat(this.state.Custom_ModelArray[0].sharpeRatio).toFixed(1)} </Td> 
                
               </Tr>
                ))}



                  </Tbody>
                  ):(<Tbody>
                  
                    <Tr><Td colspan="5">Please click reload to view results</Td></Tr></Tbody>)}
                </Table>


<br/><br/>

             </div>  
      </div>
           
           <p><b>Disclaimer:</b> These model portfolios are illustrations and is provided for educational and/or informational purposes only. They are not intended as investment advice or recommendations.</p>
           <div><h5>For more details, please contact</h5>
               <p><i className="fa fa-envelope-o" aria-hidden="true"></i> <b>Email:</b> <a href="mailto:cs@watarpartners.com">cs@watarpartners.com</a> </p>
               </div>
      
      </div>

    

      {this.state.reloadbtn==true?(
      <div className="export-buttons-div">
         {/*
        <a className="share-btn exp-pdf-btn" onClick={e => this.printDocument('__customized-tabtoPDF__')}>

        Export To PDF
      </a>
      */}
        

        
      <a className="share-btn exp-pdf-btn btn-success" onClick={e => this.GenerateCustomPdf(this.state.CalculatedModelType ,this.state.Custom_ModelArray[0].name, this.state.Custom_ModelArray[0].returnValue,this.state.Custom_ModelArray[0].yield,this.state.Custom_ModelArray[0].standardDeviation,this.state.Custom_ModelArray[0].sharpeRatio, this.state.Custom_ModelArray)}>

{/* Generate PDF */}

{this.state.pdfGenerationButtonText}
            
  
</a>
&nbsp;


   <div className="share-btn btn-primary"     onClick={e => this.emailCustomUser(this.state.CalculatedModelType ,this.state.Custom_ModelArray[0].name, this.state.Custom_ModelArray[0].returnValue,this.state.Custom_ModelArray[0].yield,this.state.Custom_ModelArray[0].standardDeviation,this.state.Custom_ModelArray[0].sharpeRatio, this.state.Custom_ModelArray)}>
        
       

            Send Via Email
        </div>
        <p>{this.state.emailMessage}</p>
      </div>):''}
      
      </div>)
      }

         
                    </div>



                    {/* Keywords */}

                    <div className="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                    
                  <div className="annual-charts-wrapper">
                    <div className="row">
                       <div className="col-md-12">
                       <div className="table-responsive">
               



               <Table className="table table-borderless asset-table">
                                   <Thead>
                                     <Tr>
                                       <Th>Keyword</Th>
                                       <Th>Description</Th>
                                     </Tr>
                                   </Thead>
                                   <Tbody>
                                     
                                    
                                   
                                        <Tr>
                                        <Td>Amount Invested</Td>
                                        <Td>Represents the cash invested during a period, including initial investment and any capital calls after the initial investment.</Td>
                                      </Tr>

                                      <Tr>
                                        <Td>Annualized Yield</Td>
                                        <Td>This is the annual rate of Dividend and Distribution Income (or Monthly Yield) from an investment over a holding period. It is calculated as Monthly Yield * 12. Dividend and distribution income used in the formula includes cash received and / or amount accrued.</Td>
                                      </Tr>


                                      <Tr>
                                        <Td>Asset Class</Td>
                                        <Td>A group of investments that share a similar return and risk profile. These are:

<ul>
    <li>    Cash and Cash Equivalents: Represents bank balances and deposits, including money markets instruments that can be liquidated within 3 months.</li>
    <li>    Liquid Investments: Includes discretionary, non-discretionary and self-managed public market portfolios with up to 12 months liquidity.</li>
    <li>      Private Debt: Includes investments in debt instruments of private companies or in special debt products such as CLO (Collateralized Debt Obligations). These include direct investments and investments in private debt funds.</li>
    <li>     Private Equity: Includes investments in equity instruments of non-listed companies, including investments in funds that invest in such companies.</li>
    <li>     Real Estate: Includes the below 2 sub-asset classes:</li>
    <ol>
    <li>   Real Estate – Yielding: Includes investment in private yielding real estate assets. These include direct investments in real estate companies and investments in real estate funds.</li>
<li>    Real Estate – Developments: Includes investments in private real estate development projects. These include direct investments in real estate development projects and investments in funds that invest in real estate development projects.</li>
</ol>
<li>    Land and Properties Bank: Includes investment in lands, buildings, and properties, which do not fall into the Real Estate category.</li>
<li>      Borrowing: Includes loans from banks and other entities that are used to fund the investments in the portfolio.</li>
<li>      Other Financial Assets: Includes investments that are not classified into any of the above asset classes.</li>  
</ul>
</Td>
                                      </Tr>

                                      <Tr>
                                        <Td>Capital Distribution</Td>
                                        <Td>Represents the cash received on an investment as return of capital. It is either equal to or less than the Amount Invested e.g., in case of a loss-making investment.</Td>
                                      </Tr>

                                      <Tr>
                                        <Td>Capital Gain</Td>
                                        <Td>Represents the cash received on an investment over and above the Cash Outflow (please see definition of Cash Outflow).</Td>
                                      </Tr>



                                      <Tr>
                                        <Td>Cash Inflow</Td>
                                        <Td>Represents the sum of Capital Distribution, Dividend Distribution and Capital Gain.</Td>
                                      </Tr> 
                                      
                                      <Tr>
                                        <Td>Cash Outflow</Td>
                                        <Td>Represents sum of Amount Invested and Fees and Expenses paid in cash.</Td>
                                      </Tr> 
                                      
                                      <Tr>
                                        <Td>Cash Transactions</Td>
                                        <Td>In some cases, there are transactions relating to bank accounts for which information is not available. These transactions are reported in the 'Cash Transactions' account.</Td>
                                      </Tr>


                                      <Tr>
                                        <Td>Dividend and Distribution</Td>
                                        <Td>Represents the amount received (Cash Dividend and Distribution) plus any amount accrued (Dividend Accrued) on an investment as yield such as dividend income from Liquid Investments or lease income from Real Estate Investments.</Td>
                                      </Tr>


                                      <Tr>
                                        <Td>Fees and Expenses</Td>
                                        <Td>This includes fees and expenses accrued plus paid on investments, bank accounts, and loans, such as:
                                         
                                         <ul>
                                            <li> management fees </li> 
                                            <li> operational and legal fees </li> 
                                            <li>  bank charges and custody fees </li> 
                                            <li> interest on borrowing </li> 
                                            <li> performance fees </li> 
                                          </ul>
                                          </Td>
                                      </Tr>


                                      <Tr>
                                        <Td>Illiquid</Td>
                                        <Td>Is an attribute for investments which cannot be liquidated over the next 12 months. These generally include Private Equity, Real Estate, Private Debt and Land and Property Bank (see Asset Class).</Td>
                                      </Tr>

                                      <Tr>
                                        <Td>Internal Rate of Return (IRR)</Td>
                                        <Td>It is defined as the rate of return that makes the net present value (NPV) of all cash flows of an investment equal to zero. It is calculated as follows: Sum of Product of [Net Cash Inflow/[(1 + IRR) ^ Number of Time Periods] - Total Cash Outflow]</Td>
                                      </Tr>

                                 <Tr>
                                    <Td>International</Td>
                                    <Td>Is an attribute for investments whose primary business is outside the MENA region, mainly in global developed markets.</Td>
                                 </Tr>

                                 <Tr>
                                    <Td>Liquid</Td>
                                    <Td>Includes investments which can be liquidated over the next 12 months. These generally include asset classes of Cash and Cash Equivalents, and Liquid investments (see Asset Class).</Td>
                                 </Tr>


                                 <Tr>
                                    <Td>Multiple on Invested Cash (MoIC)</Td>
                                    <Td>It is calculated as an investment’s total value as a multiple of its cost basis. It is calculated as [(Total Cash Inflow + Current NAV) / Total Cash Outflow].</Td>
                                 </Tr>


                                 <Tr>
                                    <Td>Net Asset Value (NAV) – at investment level</Td>
                                    <Td>Represents valuation of an investments based on the latest available valuation report from asset managers or publicly available market valuations.</Td>
                                 </Tr>
                                                                     

                                 <Tr>
                                    <Td>Net Asset Value (NAV) – at portfolio level</Td>
                                    <Td>Represents total of the Gross Asset at investment level less borrowing (see asset class).</Td>
                                 </Tr>


                                 <Tr>
                                    <Td>Net Return</Td>
                                    <Td>This is the sum of all return net of fees and expenses. Return includes dividend and distribution income, capital gains and loss and unrealized gains and losses. (Please see the definition of fees and expenses for details.)</Td>
                                 </Tr>


                                 <Tr>
                                    <Td>Equity Inflow/(Outflow)</Td>
                                    <Td>The total amount injected into or withdrawn from the portfolio or an investment as applicable.  </Td>
                                 </Tr>

                                 <Tr>
                                    <Td>Non – Yielding</Td>
                                    <Td>Is an attribute for investments which do not distribute regular cashflow income.</Td>
                                 </Tr>


                                 <Tr>
                                    <Td>Realized Net Return</Td>
                                    <Td>Includes sum of:
                                       <ul>
                                       <li>      capital gains (or losses) from exit of an asset at a value higher (or lower) than the original cost of investment.</li>
                                 <li>      cash dividend and distributions received from an investment.</li>
                                 <li>     total cash fee and expenses paid on an investment such as management fee, performance fee and legal fees etc.</li>
                               
                               </ul>
                                 </Td>
                                 </Tr>

                                 <Tr>
                                    <Td>Regional</Td>
                                    <Td>Is an attribute for investments whose primary business is in the MENA region.</Td>
                                 </Tr>


                                 <Tr>
                                    <Td>Time-Weighted Rate of Return (TWRR)</Td>
                                    <Td>This is a measure of the compound rate of growth in a portfolio or an investment. The time-weighted rate of return breaks up the return on an investment into monthly intervals.</Td>
                                 </Tr>

                                 <Tr>
                                    <Td>Unrealized Gain/(loss)</Td>
                                    <Td>Includes increase (or decrease) in the net asset value of an investment currently held.</Td>
                                 </Tr>


                                 <Tr>
                                    <Td>Unrealized Net Return</Td>
                                    <Td>Includes:
                                       <ul>
                                 <li>      dividend that has been declared but not yet received. (Dividend Accrued).</li>
                                 <li>       fee and expenses that have been accrued but have not been paid.</li>
                                 <li>       unrealized gain/(loss) on investments held. </li>
                                 </ul>
                                 </Td>
                                 </Tr>



                                 <Tr>
                                    <Td>Yielding</Td>
                                    <Td>Is an attribute for investments which distribute regular cashflow income such as lease income from real estate, and interest income from Private Debt.</Td>
                                 </Tr>
                                   </Tbody>
                                 </Table>
               
               
               
               
               
                              </div>
                       </div>
                      
                    </div>

                   
                  </div>
         
                    </div>
                   
                  </div>
                
                </div>
              </div>
        </div>
      


    
     


    
       <div hidden className="btn modal-back-btn back-button" id="go-back-slider">
                           <img alt = "back" src="assets/back_arrow.svg" width="25px" height="45px"/>
                           Back
            </div>

            <Modal id="biodata-modal" size="md" dialogClassName="modal-90w" show={this.state.showModal} backdrop="static" onHide={this.closeModal.bind(this)}>
               <Modal.Header>
                  <Modal.Title style={{width:'95%'}}>
                     <div className="modal-heading">How can we contact you?</div>
                  </Modal.Title>
                  {/*<a style={{width:'5%'}} onClick={this.closeModal.bind(this)}><i className="fa fa-times"></i></a> */}
               </Modal.Header>
               <Modal.Body >
                  <div>
                     <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                           <div className="modal-body">
                              <div className="row">
                                 <div className="col-md-6 ">
                                    <div className="form-group">
                                       <label>First Name*</label>
                                       <input type="text" className="form-control" value={this.state.fname}  onChange={this.onChangeFirstName} id="firstName" placeholder="Enter your first name" />
                                    </div>
                                 </div>
                                 <div className="col-md-6">
                                    <div className="form-group">
                                       <label>Last Name</label>
                                       <input type="text" className="form-control" value={this.state.lname}  onChange={this.onChangeLastName} id="lastName" placeholder="Enter your last name" />
                                    </div>
                                 </div>
                              </div>
                          
                              <div className="row">
                                 <div className="col-md-6 ">
                                    <div className="form-group"     style={{display: 'none'}}>
                                       <label>Contact Number*</label>
                                       <input type="tel" className="form-control" id="inputEmail" value={this.state.contact}   onChange={this.onChangeContact} placeholder="Enter your contact number" />
                                    </div>
                                 </div>
                                 <div className="col-md-12 ">
                                    <div className="form-group">
                                       <label>Email Address*</label>
                                       <input type="email" onChange={this.onChangeEmail} value={this.state.email} className="form-control" id="inputEmail" placeholder="Enter your email address" />
                                    </div>
                                 </div>
                              </div>
                              {!this.state.submitted ? (
                              <div>
                                 <div className="row">
                                    <div className="col-md-1">
                                    </div>
                                    <div className="col-md-10">
                                       <div className="form-group">
                                          <button type="submit" onClick={this.actionModalSubmit.bind(this)} className="btn modal-next-btn" id="submit-button">Submit</button>
                                       </div>
                                    </div>
                                    <div className="col-md-1">
                                    </div>
                                 </div>
                                 <div className="row">
                                    <div className="col-md-1">
                                    </div>
                                    <div className="col-md-10">
                                       <div className="form-group">
                                          <button  onClick={this.closeModalAndGoBack.bind(this)} className="btn modal-back-btn back-button">
                                          <img alt = "back" src="assets/back_arrow.svg" width="25px" height="25px"/>
                                          Back
                                          </button>
                                       </div>
                                    </div>
                                    <div className="col-md-1">
                                    </div>
                                 </div>
                              </div>
                              ) :  (     
                              <div className="row">
                                 <div className="col-md-1">
                                 </div>
                                 <div className="col-md-10">
                                    <div className="form-group">
                                       <button type="submit" onClick={this.closeModal.bind(this)} className="btn modal-next-btn" id="submit-button">Close</button>
                                    </div>
                                 </div>
                                 <div className="col-md-1">
                                 </div>
                              </div>
                              )}
                              <p id="bioerrorMessage" style={{color:"red",width: '100% !important',textAlign:'center'}}></p>
                              <p  id="biosuccessMessage" style={{color:"green",width: '100% !important',textAlign:'center'}}></p>
                           </div>
                        </div>
                     </div>
                  </div>
               </Modal.Body>
            </Modal>




            <Modal id="TanC-modal" size="lg" dialogClassName="modal-90w" show={this.state.showModalTandC} backdrop="static" onHide={this.closeModalTandC.bind(this)}>
               <Modal.Header>
                  <Modal.Title style={{width:'95%'}}>
                     <div className="modal-heading">Terms & Conditions</div>
                  </Modal.Title>
                  <a style={{width:'5%'}} onClick={this.closeModalTandC.bind(this)}><i className="fa fa-times"></i></a> 
               </Modal.Header>
               <Modal.Body >
                  
                     <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                           <div className="modal-body">
                              <div className="">
                                 <div className="col-md-12">
                                 <b>Risk Profile Questionnaire—Terms and conditions of use</b><br/>
How you allocate your capital amongst different asset classes may be the most important factor in determining the long-term return and volatility of your portfolio. 
The Risk Profile Questionnaire makes asset allocation suggestions based on information you enter about your investment objectives and experience, time horizon, risk tolerance, and financial situation. As your financial circumstances or goals change, it may be helpful to complete the questionnaire again and to reallocate the investments in your portfolio. The Risk Profile Questionnaire is provided for educational and/or informational purposes only and does not constitute investment advice.

To use the Risk Profile Questionnaire, you should read the limitations and accept our terms and conditions of use.<br/><br/>

<b>Consent to electronic delivery and terms and conditions of use</b><br/>
The Risk Profile Questionnaire is designed to help you decide how to allocate your assets among different asset classes (public & private stocks, bonds, and short-term reserves). You are under no obligation to accept the suggested allocations provided by this questionnaire.
In applying a particular asset allocation to your situation, you should consider your other assets and sources of income (e.g., equity in a home, IRA investments, savings accounts, and interest in other qualified and non-qualified plans) in addition to your interests in this account.
The allocations provided are based on generally accepted investment principles. There is no guarantee, however, that any particular asset allocation or mix of funds will meet your investment objectives. All investments involve risks, and fluctuations in the financial markets and other factors may cause declines in the value of your account. You should carefully consider all of your options before investing.
The Risk Profile Questionnaire is provided to you free of charge. It does not provide comprehensive investment or financial advice. Watar Partners or its affiliates are not responsible for reviewing your financial situation or updating the suggestions contained herein.

<br/><br/>By clicking I agree, you agree to the terms outlined on this page.<br/><br/>


<b>Duration of election and consent</b><br/>
Your consent applies only to this particular request. If you request additional information, you may be required to consent to electronic delivery again.<br/><br/>



<b>Costs and risks</b><br/>
Watar Partners does not charge you a fee to use our website, but you could incur expenses from an Internet service provider when you access information online. Also, be aware that your Internet service provider may occasionally experience system failure and hyperlinks to documents may not function properly.<br/><br/>

<b>Risk Profile Questionnaire—Limitations</b><br/>
Caveats on the questionnaire's ability to provide financial forecasts
As you use the questionnaire, keep the following limitations in mind:<br/>
The suggested asset allocations within the questionnaire depend on subjective factors such as your risk tolerance and financial situation. For this reason, you should view them only as broad guidelines for how you might consider investing your savings. It's important to review historical returns of short-term investments, bonds, and stocks carefully over various holding periods to see if you can accept the level of risk in a given investment mix.<br/>
The asset allocations are limited to various broad classes of investments and do not include all potential asset classes.<br/>
The investment returns represented in the questionnaire are based on historical index returns from a pre-selected time period and are not intended to indicate future performance.<br/>
Any modifications to your current mix of investments should be made gradually to lessen the impact of significant market changes and potential tax effects.<br/>
The Risk Profile Questionnaire is intended to provide guidelines to help you design a savings and investment program. It doesn't provide comprehensive investment advice, such as advice on buying a specific stock or bond and shouldn't be considered the sole or primary basis on which you make investment decisions. You may wish to consult a professional investment advisor, accountant, attorney, or broker before making an investment.<br/>
Your financial projections greatly depend on your assumptions, especially for inflation rate, investment expenses, taxes, and investment return. It's difficult to forecast such rates and returns accurately, especially over long periods. Therefore, it's critical that you update your projections periodically to accommodate any changes in your assumptions.<br/>
The longer your time horizon, the more likely any change in your assumptions will have a significant impact on your results. Even small changes can lead to substantial variations in results over time. A 1% change in your investment return can have a significant impact on your ability to meet your retirement goals over the long term.<br/>
Financial projections aren't mistake-proof and can't ensure specific future results. Changes in tax or benefit laws, investment markets, or your own financial situation can cause actual results to deviate substantially from your projection. To address this uncertainty, you should create several scenarios, with various sets of assumptions, to evaluate a wide range of possible outcomes.<br/>
The Risk Profile Questionnaire doesn't provide comprehensive investment advice. It's important to revise your financial profile periodically based on your experience and changing goals.<br/>

                                 </div>
                             
                              </div>
                              </div>
                          
                           
                              
                        </div>
                     </div>
                  
               </Modal.Body>
            </Modal>




            <Modal id="biodata-modal" size="md" dialogClassName="modal-90w" show={this.state.showModalSkipSteps} backdrop="static" onHide={this.closeModalSkipSteps.bind(this)}>
               <Modal.Header>
                  <Modal.Title style={{width:'95%'}}>
                     <div className="modal-heading">Proceed To Model Portfolio</div>
                  </Modal.Title>
                   
               </Modal.Header>
               <Modal.Body >
                  
                     <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                           <div className="modal-body">
                             
                                 
                                <ul style={{padding:'5px'}}>
<li>This questionnaire will help us to suggest best suitable model portfolio for you.</li><br/>
<li>Still you want to skip these steps and proceed to model portfolio? </li>

</ul>

<button onClick={this.closeModalSkipStepsAndOpenOther.bind(this)}     className="btn next-btn btn-success" style={{width:"48%"}}>Yes</button> &nbsp;
<button onClick={this.closeModalSkipSteps.bind(this)}                 className="btn next-btn btn-danger" style={{width:"48%"}}>No</button>


                                 
                             
                              
                              </div>
                          
                           
                              
                        </div>
                     </div>
                  
               </Modal.Body>
            </Modal>
 
    

</div>

{/* ///////////////////// */}


            </div>
         </section>
         </div> 
      </div>
  
   );
}
}